/* ============================================================
 * VERSIONS — Dictionnaire i18n FR / EN
 * ------------------------------------------------------------
 * Organisation : clés groupées par namespace (common, nav,
 * auth, home, input, loading, fiche, versions, reglages,
 * modals, sidebar, player, chat, errors, datetime…).
 * ------------------------------------------------------------
 * Les noms de projets, titres, artistes saisis par l'utilisateur
 * ne sont PAS des clés de traduction — ils restent bruts.
 * ============================================================ */

const STRINGS = {
  fr: {
    /* ─────────────────────────── COMMUN ────────────────────── */
    common: {
      loading: "CHARGEMENT...",
      save: "Enregistrer",
      saving: "Enregistrement...",
      saved: "✓ Enregistré",
      cancel: "Annuler",
      delete: "Supprimer",
      rename: "Renommer",
      create: "Créer",
      close: "Fermer",
      confirm: "Confirmer",
      ok: "OK",
      back: "Retour",
      continue: "Continuer",
      next: "Suivant",
      prev: "Précédent",
      yes: "Oui",
      no: "Non",
      search: "Rechercher",
      reset: "Réinitialiser",
      tryAgain: "Réessayer",
      optional: "(optionnel)",
      required: "Obligatoire",
      copy: "Copier",
      copied: "Copié !",
      share: "Partager",
      edit: "Modifier",
      add: "Ajouter",
      // Pill flottante "Ajouter" (côté gauche, miroir du chat pill).
      // Sub-label visible quand la pill s'étend au hover.
      addPillPlaceholder: "Projet, titre, version",
      or: "ou",
      of: "sur",
      and: "et",
      by: "par",
      to: "à",
      from: "depuis",
      all: "Tous",
      none: "Aucun",
      unknown: "Inconnu",
      untitled: "Sans titre",
      untitledMale: "Sans nom",
      pending: "En attente",
      inProgress: "En cours",
      done: "Terminé",
      more: "Plus",
      less: "Moins",
      showMore: "Voir plus",
      showLess: "Voir moins",
      viewDetails: "Voir les détails",
      hide: "Masquer",
      show: "Afficher",
      new: "Nouveau",
      newFem: "Nouvelle",
      processing: "Traitement…",
      generating: "Génération…",
      analysing: "Analyse en cours…",
      track: "titre",
      tracks: "titres",
      version: "version",
      versions: "versions",
      project: "projet",
      projects: "projets",
    },

    /* ─────────────────────────── NAV ───────────────────────── */
    nav: {
      home: "Accueil",
      versions: "Versions",
      chat: "Chat",
      reglages: "Réglages",
      profile: "Profil",
      back: "Retour",
      newAnalysis: "Nouvelle analyse",
    },

    /* ─────────────────────────── BRAND ─────────────────────── */
    brand: {
      tagline: "Versioning de productions audio",
      taglineAction: "Analyse · Compare · Évolue",
    },

    /* ─────────────────────────── AUTH ──────────────────────── */
    auth: {
      signInTitle: "SE CONNECTER",
      signUpTitle: "CRÉER MON COMPTE",
      signInTab: "Se connecter",
      signUpTab: "Créer un compte",
      signIn: "Se connecter",
      signUp: "S'inscrire",
      signOut: "Se déconnecter",
      google: "Continuer avec Google",
      apple: "Continuer avec Apple",
      facebook: "Continuer avec Facebook",
      or: "OU",
      orEmail: "ou par email",
      email: "Email",
      password: "Mot de passe",
      forgotPassword: "Mot de passe oublié ?",
      confirmEmail: "Vérifiez votre email pour confirmer votre compte.",
      noAccount: "Pas de compte ? S'inscrire",
      alreadyRegistered: "Déjà inscrit ? Se connecter",
      cgu1: "En continuant, tu acceptes les",
      cgu2: "Conditions d'utilisation",
      cgu3: "et la",
      cgu4: "Politique de confidentialité",
      // Mention Archipel Audio (migration 052). Texte versionné : toute
      // modification = nouvelle version dans src/lib/archipelConsent.js
      // + nouvelle ligne dans public.archipel_text_versions.
      archipelNotice: "Versions est un outil Archipel Audio. On t'enverra de temps en temps nos outils pour musiciens (AudioKit, AudioPass, Poll the Band). Désinscription en un clic dans chaque email.",
      archipelPrivacy: "Politique de confidentialité",
      archipelRefuse: "Je ne souhaite pas les recevoir",
      // Flow réinitialisation mot de passe
      resetTitle: "Mot de passe oublié",
      resetSubtitle: "Entre ton email, on t'envoie un lien pour choisir un nouveau mot de passe.",
      resetSubmit: "Envoyer le lien",
      resetSent: "Email envoyé. Clique sur le lien pour choisir un nouveau mot de passe.",
      backToSignIn: "Retour à la connexion",
      // Écran nouveau mot de passe (après clic sur le lien email)
      updateTitle: "Choisis un nouveau mot de passe",
      updateSubtitle: "Tu peux maintenant définir un nouveau mot de passe pour ton compte.",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirme le mot de passe",
      updateSubmit: "Mettre à jour",
      updateSuccess: "Mot de passe mis à jour. Tu peux te connecter avec.",
      updatePasswordMismatch: "Les deux mots de passe ne correspondent pas.",
      updatePasswordTooShort: "Le mot de passe doit faire au moins 6 caractères.",
      updateLinkExpired: "Le lien a expiré. Demande un nouveau mail de réinitialisation.",
      // Erreurs Supabase Auth — traduites pour ne plus afficher l'anglais brut
      errInvalidCredentials: "Email ou mot de passe incorrect.",
      errSamePassword: "Le nouveau mot de passe doit être différent de l'ancien.",
      errWeakPassword: "Mot de passe trop court (6 caractères minimum).",
      errUserAlreadyRegistered: "Un compte existe déjà avec cet email. Essaie de te connecter.",
      errEmailNotConfirmed: "Email non confirmé. Vérifie ta boîte mail (et les spams).",
      errInvalidEmail: "Email invalide.",
      errRateLimit: "Trop de tentatives. Réessaie dans quelques minutes.",
      errEmailRateLimit: "Trop de mails envoyés. Patiente quelques minutes avant de réessayer.",
      errOtpExpired: "Ce lien a expiré. Demande-en un nouveau.",
      errOAuth: "La connexion via Google a échoué. Réessaie ou utilise email + mot de passe.",
      errSignupsDisabled: "Les inscriptions sont temporairement fermées.",
      errNetwork: "Connexion impossible. Vérifie ta connexion internet et réessaie.",
      errGeneric: "Une erreur est survenue. Réessaie dans un instant.",
    },

    /* ─── Confirmation de suppression de compte (route /confirm-delete-account) ─── */
    deleteAccount: {
      confirmFinalTitle: "Suppression de compte",
      confirmFinalMessage: "Tu es sur le point de supprimer définitivement ton compte Versions et toutes les données associées. Cette action est irréversible.",
      confirmFinalBtn: "Supprimer définitivement",
      confirmCancelBtn: "Annuler",
      confirmedTitle: "Compte supprimé ✓",
      confirmedMessage: "Ton compte a bien été supprimé. Tu vas être redirigé vers l'accueil dans un instant.",
      confirmTokenInvalid: "Ce lien a expiré ou n'est plus valide. Refais une demande de suppression depuis tes Réglages.",
      confirmFailed: "Une erreur est survenue. Réessaie ou écris-nous à contact@versions.studio.",
      invalidLinkTitle: "Lien invalide",
      invalidLinkMessage: "Ce lien ne contient pas de jeton de confirmation. Refais une demande de suppression depuis tes Réglages.",
    },

    /* ─────────────────────────── HOME / WELCOME ────────────── */
    home: {
      greeting: "SALUT !",
      greetingWithName: "SALUT {name} !",
      newTrack: "Nouveau titre",
      newVersion: "Ajouter une version",
      pickTrack: "À quel titre ?",
      myTracks: "Mes",
      myTracksAccent: "titres",
      empty: "Importe ton premier titre pour commencer l'aventure.",
      tipLabel: "Tips de production",
      ctaAnalysis: "Analyse",
      playing: "En lecture",
      play: "Écouter",
      pause: "Pause",
      add: "Ajouter",
      userMenu: "Menu utilisateur",
      logout: "Se déconnecter",
      settings: "Réglages",
      fallbackUser: "utilisateur",
      projectKicker: "Projet",
      projectOptions: "Options du projet",
      share: "Partager / Membres",
      shareTrack: "Partager ce titre",
      projectAvgScore: "Score moyen",
      searchPlaceholder: "Rechercher un projet, un titre…",
      searchNoResults: "Aucun résultat",
      searchProjectsLabel: "Projets",
      searchTracksLabel: "Titres",
      searchHint: "↑↓ naviguer · Entrée ouvrir · Échap fermer",
      searchClear: "Effacer la recherche",
      myProjects: "Mes",
      myProjectsAccent: "projets",
      sharedWithMe: "Partagés",
      sharedWithMeAccent: "avec moi",
      emptyProject: "Aucun titre pour l'instant.",
      newTrackInProject: "+ Nouveau titre",
      rename: "Renommer",
      replaceImage: "Remplacer l'image",
      changeImage: "Changer l'image",
      removeImage: "Retirer l'image",
      trackReplaceImage: "Remplacer l'illustration",
      trackChangeImage: "Ajouter une illustration",
      trackRemoveImage: "Retirer l'illustration",
      delete: "Supprimer",
      cancel: "Annuler",
      ok: "OK",
      newProject: "Nouveau projet",
      projectNamePlaceholder: "Nom du projet",
      trackNamePlaceholder: "Nom du titre",
      renameTrackTitle: "Renommer le titre",
      renameProjectTitle: "Renommer le projet",
      confirmRename: "Renommer",
      confirmCreate: "Créer",
      emptyProjectsMobile: "Crée ton premier projet pour commencer l'aventure.",
      heroResume: "Reprends où tu étais",
      heroPlaying: "En lecture",
      heroListen: "Écouter",
      heroPause: "Mettre en pause",
      heroPlayTrack: "Lire ce titre",
      heroPlayProject: "Lire le projet",
      heroScoreLabel: "— Score du mix",
      viewFiche: "Voir la fiche",
      newVersionShort: "Nouvelle version",
      impossible: "Impossible",
      lastProjectMsg: "Au moins un projet est requis. Crée un autre projet avant de supprimer celui-ci.",
      lastProjectMsgShort: "Au moins un projet est requis.",
      deleteProjectTitle: "Supprimer le projet ?",
      deleteProjectMsgEmpty: "Supprimer le projet \"{name}\" ?",
      deleteProjectMsgWithTracks: "Supprimer le projet \"{name}\" et ses {n} {trackWord} (avec toutes leurs versions et fichiers audio) ? Cette action est définitive.",
      deleteTrackTitle: "Supprimer le titre ?",
      deleteTrackMsg: "Supprimer \"{name}\" et ses {n} {versionWord} ? Cette action est définitive.",
      statsTracks: "Titres",
      statsVersions: "Versions",
      statsAvgScore: "Score moyen",
      statsProgress: "Progression",
      projectSingular: "projet",
      projectPlural: "projets",
      versionSingular: "version",
      versionPlural: "versions",
      trackSingular: "titre",
      trackPlural: "titres",
      analysisSingular: "analyse",
      analysisPlural: "analyses",
      statsOn: "sur",
      statsNoAnalysis: "aucune analyse",
      statsEmptyCurve: "Analyse quelques titres pour voir ta courbe.",
      statsRecentAnalyses: "{n} dernières analyses",
      statsCurveBuilding: "courbe en construction",
      relativeToday: "aujourd'hui",
      relativeYesterday: "hier",
      relativeDaysAgo: "il y a {n}j",
      relativeWeeksAgo: "il y a {n}sem",
      relativeMonthsAgo: "il y a {n} mois",
      relativeDash: "—",
      // Ligne meta d'une carte projet sur la Home desktop (sous le titre).
      lastAnalysis: "dernière analyse {when}",
      noAnalysisYet: "aucune analyse",
      cardYourProgress: "Ta progression",
      cardAvgScore: "Score moyen {n}/100",
      cardLaunchFirst: "Lance ta première analyse",
      cardNextStep: "Prochain pas",
      cardLastAnalyzed: "Dernier titre analysé",
      cardLastAnalyzedEmpty: "Aucune analyse pour l'instant.",
      cardWhyUseful: "À quoi ça sert ?",
      cardWhyVersions: "Pourquoi « Versions » ?",
      cardAdvice: "Conseil",
      // Titres des 2 blocs de la colonne droite (home desktop)
      rightSectionYou: "Recommandations",
      rightSectionKnow: "Le saviez-vous ?",
      welcomeHi: "Bienvenue",
      welcomeHiName: "Bienvenue, {name}",
      onboardingTagline: "VERSIONS analyse tes mix et compare tes versions entre elles. Commençons par un premier titre.",
      // Slogan Home desktop — titre fixe (le mot accentué est italique ambre en CSS).
      sloganStart: "Écoute, ",
      sloganEm: "compare",
      sloganEnd: ", décide.",
      // Eyebrow au-dessus du slogan (violet). {name} et {n} interpolés.
      heroEyebrowWelcome: "Bienvenue {name} — commençons ton premier titre",
      heroEyebrowActive: "Bonjour {name} — {n} titres prêts à être écoutés",
      heroEyebrowActiveSingle: "Bonjour {name} — 1 titre prêt à être écouté",
      firstTrack: "+ Mon premier titre",
      firstProject: "+ Mon premier projet",
      gettingStarted: "Mise en route",
      checkCreateProject: "Créer ton premier projet",
      checkFirstTrack: "Analyser un premier titre",
      checkCompare: "Comparer deux versions",
      checkExploreChat: "Explorer les questions au chat",
      trackDragHandle: "Glisser pour déplacer le titre",
      trackMove: "Déplacer le titre",
      trackOptions: "Options",
      trackAnalysis: "Voir fiche",
      tips: [
        "Faire des pauses régulières permet de conserver une écoute attentive et objective.",
        "Tes oreilles se fatiguent après 45 min — une pause de 10 min te fait gagner 2h de travail.",
        "Écouter ton mix dans un autre contexte (voiture, écouteurs) révèle ce que le studio cache.",
        "Baisser le volume de monitoring aide à repérer les déséquilibres de balance.",
        "Prendre du recul sur un mix pendant 24h change complètement ta perception.",
        "Comparer régulièrement avec une référence recalibre ton oreille et tes choix.",
        "Le silence entre les sessions est aussi important que le travail lui-même.",
        "Écouter à faible volume est le meilleur test : si le mix fonctionne bas, il fonctionnera fort.",
      ],
    },

    /* ─────────────────────────── INPUT ─────────────────────── */
    input: {
      title: "NOUVELLE ANALYSE",
      tagline: "Analyse · Compare · Évolue",
      taglineWord1: "Analyse",
      taglineWord2: "Compare",
      taglineWord3: "Évolue",
      tracksSingular: "titre",
      tracksPlural: "titres",
      confirmCreate: "Créer",
      sectionMix: "TON MIX",
      sectionVocalType: "TYPE DE TITRE",
      sectionProject: "PROJET",
      sectionTitle: "TITRE",
      sectionVersion: "VERSION",
      sectionDaw: "TON DAW",
      titlePlaceholder: "Nom du morceau",
      versionPlaceholder: "ex: Mix v3, Demo, Master…",
      dawPlaceholder: "Sélectionne ton DAW…",
      dropText: "Glisser le fichier ici ou cliquer",
      dropFormats: "WAV (recommandé) · MP3 · FLAC — 70 Mo max",
      vocalSung: "Chanté",
      vocalInstrumental: "Instrumental",
      vocalVoiceQuestion: "VOIX SUR CE TITRE ?",
      vocalComing: "À venir",
      vocalFinal: "Instrumental définitif",
      vocalComingTip: "Tu prévois d'ajouter des voix sur une prochaine version",
      vocalFinalTip: "Œuvre purement instrumentale, pas de voix prévue",
      vocalHintIdle: "Ce choix évite que l'absence de voix soit notée comme un défaut à tort.",
      vocalHintComing: "L'analyse traitera la voix comme une étape à franchir.",
      vocalHintFinal: "La section voix sera ignorée dans l'analyse et le score.",
      projectPickerFirst: "+ Crée ton premier projet",
      projectPickerNew: "+ Nouveau projet",
      projectLocked: "Projet verrouillé — ce titre est déjà rattaché à un projet",
      projectLockedHint: "Projet verrouillé — ce titre appartient déjà à ce projet.",
      analyze: "Analyser",
      fieldsRemaining: "{filled}/{total} champs remplis",
      newProjectTitle: "Nouveau projet",
      newProjectPlaceholder: "Nom du projet",
    },

    /* ─────────────────────────── LOADING ───────────────────── */
    loading: {
      title: "ANALYSE EN COURS",
      sub: "Ton mix est en train d'être décortiqué.",
      cancel: "Annuler l'analyse",
      stepUpload: "Envoi du fichier",
      stepListen: "Écoute qualitative",
      stepExtract: "Extraction des éléments",
      stepDetectVocal: "Détection vocale",
      stepBuildFiche: "Construction de la fiche",
      stepSynthesis: "Synthèse finale",
      stageListening: "On écoute ton morceau…",
      stageAnalyzing: "Rédaction du diagnostic…",
      stageRag: "Croisement avec la base de connaissances…",
      stageFinal: "Dernière relecture…",
      errorTitle: "L'analyse a échoué",
      errorRetry: "Réessayer",
      errorBack: "Revenir en arrière",
      stepUploadOne: "Upload du fichier…",
      stepUploadMulti: "Upload des fichiers…",
      stepListening: "Écoute qualitative…",
      stepWriting: "Rédaction de la fiche…",
      stepDone: "Analyse terminée…",
      microUpload: "Upload",
      microListening: "Écoute",
      microWriting: "Rédaction",
      microDone: "Finalisation",
      titleBefore: "Analyse",
      titleEm: "en cours",
      didYouKnow: "Le saviez-vous ?",
      cancel: "Annuler l'analyse",
      errorDuplicate: "Fichier identique à la version \"{name}\" déjà uploadée pour ce titre.",
      errorDuplicateOtherTrack: "Tu as déjà analysé ce fichier dans le titre \"{track}\" (version \"{name}\") avec les mêmes paramètres.",
      duplicateModalTitle: "Analyse déjà existante",
      duplicateModalSeeExisting: "Voir l'analyse existante",
      duplicateModalUploadAnyway: "Uploader quand même",
      errorStart: "Démarrage échoué ({status})",
      errorFailed: "Analyse échouée",
      errorTimeout: "Timeout — analyse trop longue",
      errorCancelled: "Upload annulé",
      errorUploadFailed: "Upload du fichier échoué. Vérifie ta connexion et réessaie.",
      // Codes d'erreur stables remontés par le backend versions-api dans job.error
      // (cf. backend lib/jobErrors.js). Le mapper translateBackendError() côté
      // front les traduit en strings i18n. Ne plus afficher d'err.message brut.
      errorAnalysisTimeout: "L'analyse a pris trop de temps. Réessaie.",
      errorAnalysisService: "Un service externe est temporairement indisponible. Réessaie dans quelques minutes.",
      errorAnalysisStorage: "Problème lors de la lecture de ton fichier audio. Réessaie.",
      errorAnalysisParse: "L'analyse a échoué à la rédaction de la fiche. Réessaie.",
      errorJobNotFound: "Cette analyse n'existe plus. Relance-la depuis ton dashboard.",
      errorJobNotAwaiting: "Cette analyse n'attend plus d'intention. Relance-la depuis ton dashboard.",
      // 413 backend (audio > 12 min) — `{recv}` est rempli côté front avec
      // la durée reçue formatée (ex : " (14 min 32 s)"), vide sinon.
      errorTooLongAudio: "Audio trop long{recv}. Versions analyse les morceaux jusqu'à 12 minutes.",
      // 413 backend (multer LIMIT_FILE_SIZE, cf. server.js error handler) —
      // fichier trop lourd, indépendamment de la durée. Le seuil exact vient
      // du backend via `maxBytes` ; on affiche juste la limite, sans suggérer
      // de conversion (à l'utilisateur de s'organiser comme il veut).
      errorFileTooLarge: "Fichier trop lourd. Maximum autorisé : 80 Mo.",
      // 402 backend = solde de crédits à zéro.
      errorNoCredits: "Aucun crédit disponible. Redirection vers les tarifs…",
      dupCheckTitle: "Est-ce bien une version du même titre ?",
      dupCheckMessage: "Cette version dure {thisDur} alors que la version précédente dure {prevDur} (écart {pct}%).",
      dupCheckContinue: "Continuer l'analyse",
      dupCheckCancel: "Annuler",
      dupCheckNewTitle: "Créer un nouveau titre",
      tips: [
        "Faire des pauses régulières permet de conserver une écoute attentive et objective.",
        "Tes oreilles se fatiguent après 45 min — une pause de 10 min te fait gagner 2h de travail.",
        "Les meilleurs mix se font en sessions courtes. La qualité bat toujours la quantité.",
        "Écouter ton mix dans un autre contexte (voiture, écouteurs) révèle ce que le studio cache.",
        "Baisser le volume de monitoring aide à repérer les déséquilibres de balance.",
        "Prendre du recul sur un mix pendant 24h change complètement ta perception.",
        "Tes décisions de mix sont meilleures le matin — profite de tes oreilles fraîches.",
        "Un bon mix se fait en 10 décisions clés, pas en 100 micro-ajustements.",
        "Comparer régulièrement avec une référence recalibre ton oreille et tes choix.",
        "Le silence entre les sessions est aussi important que le travail lui-même.",
        "Écouter à faible volume est le meilleur test : si le mix fonctionne bas, il fonctionnera fort.",
        "La fatigue auditive est invisible — quand tu doutes d'un choix, c'est souvent le signe qu'il faut pauser.",
      ],
    },

    /* ─────────────────────────── FICHE ─────────────────────── */
    fiche: {
      headerBadgeRef: "MODE RÉFÉRENCE",
      headerBadgePerso: "MODE PERSONNEL",
      headerVerdict: "VERDICT",
      headerScore: "SCORE",
      tabAnalysis: "ANALYSE",
      tabAnalysisPerso: "DIAGNOSTIC",
      tabListen: "ÉCOUTE",
      tabListenPerso: "RESSENTI",
      tabChain: "CHAÎNE PROBABLE",
      tabChainPerso: "PROBLÈMES IDENTIFIÉS",
      tabPlugins: "PLUGINS IDENTIFIÉS",
      tabPluginsPerso: "OUTILS RECOMMANDÉS",
      tabReproduce: "REPRODUIRE",
      tabActionPlan: "PLAN D'ACTION",
      tabListenSecond: "ÉCOUTE APPROFONDIE",
      generating: "Génération…",
      kbActive: "Base de connaissance active",
      clickToDig: "Cliquer sur un élément pour approfondir",
      noContent: "Pas encore de contenu pour cette section.",
      sectionStrengths: "Points forts",
      sectionWeaknesses: "Lacunes",
      sectionRisks: "Risques",
      sectionSuggestions: "Suggestions",
      sectionActions: "Actions prioritaires",
      sectionNextSteps: "Prochaines étapes",
      sectionWhyThis: "Pourquoi ce choix",
      sectionHowToApply: "Comment l'appliquer",
      addVersion: "Ajouter une version",
      compareVersions: "Comparer les versions",
      viewComparison: "Voir la comparaison",
      exportPdf: "Exporter en PDF",
      sharePublic: "Lien public",
      deleteVersion: "Supprimer cette version",
      renameVersion: "Renommer la version",
      scoreOutOf: "/ 100",
      durationLabel: "Durée",
      analysedOn: "Analysé le",
      dawLabel: "DAW",
      versionLabel: "Version",
      projectLabel: "Projet",
      difficulty: "Difficulté",
      impact: "Impact",
      priority: "Priorité",
      priorityHigh: "Haute",
      priorityMedium: "Moyenne",
      priorityLow: "Basse",
      confidenceMeasured: "MESURÉ",
      confidenceIdentified: "IDENTIFIÉ",
      confidenceSuggested: "SUGGÉRÉ",
      retakeAnalysis: "Relancer l'analyse",
      fetchingFiche: "Chargement de la fiche…",
      ficheUnavailable: "Fiche non disponible",
      whatWasAnalysed: "Ce qui a été analysé",
      vocalTypeVocal: "Chanté",
      vocalTypeInstrumental: "Instrumental",
      vocalTypeInstrumentalPending: "Instrumental (voix à venir)",
      vocalTypeInstrumentalFinal: "Instrumental définitif",
      voiceComingSoon: "VOIX À VENIR",

      /* FicheScreen — rendu détaillé */
      listeningTitle: "Écoute qualitative",
      sectionSingular: "section",
      sectionPlural: "sections",
      analyzingTitle: "Analyse en cours",
      analyzingTitleEllipsis: "Analyse en cours…",
      analyzingSub1: "L'écoute qualitative et la fiche se génèrent en parallèle.",
      analyzingSub2: "Compte 30 à 90 secondes selon la longueur du titre.",
      stepUpload: "Upload audio",
      stepListening: "Écoute qualitative",
      stepFiche: "Génération de la fiche",
      didYouKnow: "Le saviez-vous ?",
      analysisTips: [
        "Une caisse claire qui manque d'air : essaie une reverb courte en send, pas en insert.",
        "Mix qui manque de punch : compression parallèle sur la bus drums, ratio 4:1 avec beaucoup de blend.",
        "Voix qui perce trop : un de-esser après le compresseur, pas avant.",
        "Kick et basse qui se battent : sidechain léger sur la basse, attack rapide, release ~120ms.",
        "Mix qui sonne plat : checke la phase entre overhead et close mics sur la batterie.",
        "Graves brouillons : EQ soustractive entre 200 et 400 Hz sur les instruments du bas.",
        "Manque de profondeur : varie les temps de reverb — courte devant, longue derrière.",
        "Voix qui chante en avant : automation du volume note par note plutôt que compression forte.",
        "Trop d'aigus agressifs : un shelf très doux à partir de 10 kHz, -1 à -2 dB suffit souvent.",
        "Stéréo qui s'effondre en mono : checke le bus mix en mono dès le début, pas à la fin.",
      ],
      trackOptionsTitle: "Options du titre",
      menuRenameTrack: "Renommer",
      menuExportTrack: "Exporter la fiche",
      menuDeleteTrack: "Supprimer le titre",
      stageAllDone: "Fiche\nd'analyse",
      stageFicheDone: "Écoute en cours",
      stageOther: "Analyse en cours",
      versionsLabel: "Versions",
      newVersionTitle: "Nouvelle version",
      ariaPrev: "Précédent",
      ariaNext: "Suivant",
      ariaClose: "Fermer",
      focusDawLabel: "Action DAW",
      focusMeasured: "Mesuré",
      focusTarget: "Objectif",
      focusLinkedItems: "Éléments liés",
      focusResolved: "Résolu",
      focusMarkResolved: "Marquer comme résolu",
      chatTitle: "Discussion",
      chatAiName: "Versions",
      chatEmpty: "Pose une question sur cette version — je regarde l'analyse et je te réponds.",
      chatPlaceholder: "Écris ta question…",
      chatSend: "Envoyer",
      chatError: "Erreur de connexion.",
      planTitle: "Plan d'action",
      planTagPriority: "Priorité",
      planTagObservation: "Observation",
      planTagResolved: "Résolu",
      adjustmentSingular: "ajustement",
      adjustmentPlural: "ajustements",
      diagTitle: "Diagnostic par éléments",
      categorySingular: "catégorie",
      categoryPlural: "catégories",
      elementSingular: "élément",
      elementPlural: "éléments",
      avgPrefix: " · moy. ",
      diagProgressDone: "complétés",
      diagProgressTitle: "Coche chaque recommandation à mesure que tu l'appliques dans ton DAW",
      diagItemMarkDoneLabel: "Marquer comme résolu",
      diagItemDoneLabel: "Résolu (clique pour décocher)",
      diagItemTodoShort: "Marquer comme résolu",
      diagItemDoneShort: "Résolu",
      renameTrackPrompt: "Nouveau nom du titre :",
      deleteTrackConfirm: 'Supprimer "{title}" et ses {n} {versionWord} ? Cette action est définitive.',
      versionSingular: "version",
      versionPlural: "versions",

      /* Intention artistique (panneau fiche) */
      intentKicker: "Intention artistique",
      intentScopePrefix: "Appliquée à",
      intentScopeTrack: "ce titre",
      intentScopeVersion: "cette version",
      intentEmpty: "Non renseignée",
      intentEdit: "Modifier",
      intentAdd: "Ajouter une intention artistique",
      intentSave: "Enregistrer",
      intentSaving: "Enregistrement…",
      intentCancel: "Annuler",
      intentPlaceholder: "Décris en une ou deux phrases l’intention artistique de ce titre (ambiance, références, ce que tu cherches à transmettre)…",
      /* Score ring tooltip + bands */
      scoreAriaLabel: "Voir les détails du score",
      scoreGlobalTitle: "Score global",
      scoreBandLow: "À retravailler",
      scoreBandMid: "En progression",
      scoreBandHigh: "Solide",
      scoreBandLowRange: "0–49 · À retravailler",
      scoreBandMidRange: "50–74 · En progression",
      scoreBandHighRange: "75–100 · Solide",
      scoreBandLowShort: "0–49",
      scoreBandMidShort: "50–74",
      scoreBandHighShort: "75–100",
      scoreCalibStable: "Calibré sur la version précédente · stable",
      scoreCalibDelta: "Calibré sur la version précédente · {delta} pts",
      scoreDeltaUp: "↑ +{delta} points depuis {prev}",
      scoreDeltaDown: "↓ -{delta} points depuis {prev}",
      scoreDeltaStable: "= stable depuis {prev}",
      scoreNote: "Le score reflète la cohérence du mix (spatialisation, dynamique, équilibre, clarté). Il est calibré pour rester comparable d'une version à l'autre du même titre.",
      /* Ticket 4.1 — plafond de score (high priority unresolved) */
      scoreFloorBadge: "Plafond {ceiling}/100",
      scoreFloorOneItem: "Plafond appliqué : 1 item prioritaire à traiter avant de pouvoir dépasser {ceiling}/100.",
      scoreFloorManyItems: "Plafond appliqué : {count} items prioritaires à traiter avant de pouvoir dépasser {ceiling}/100.",
      scoreFloorOriginal: "Score brut sans plafond : {original}/100.",

      /* Mix indicators (6 tiles dans Score Global) */
      mixIndicators: {
        balance:    { label: "Balance",    low: "Déséquilibré", mid: "Correct",  high: "Bon",
          what: "Équilibre global entre toutes les familles de son (voix, instruments, basses, batterie, spatial, master).",
          how:  "Moyenne de l'ensemble des catégories du diagnostic." },
        dynamique:  { label: "Dynamique",  low: "Plate",        mid: "Moyen",    high: "Vivante",
          what: "Respiration du mix, variation de niveau entre passages forts et doux, impact du limiting.",
          how:  "Dérivé des items de la catégorie Master & Loudness." },
        stereo:     { label: "Stéréo",     low: "Étroit",       mid: "Correct",  high: "Large",
          what: "Largeur de l'image, profondeur, placement latéral et cohérence des reverbs.",
          how:  "Dérivé des items de la catégorie Spatial & Reverb." },
        saturation: { label: "Saturation", low: "Excessive",    mid: "OK",       high: "Maîtrisée",
          what: "Chaleur harmonique et distorsion contrôlée — ni terne, ni agressif.",
          how:  "Estimé à partir du Master & Loudness (indicateur indirect tant que l'IA ne mesure pas la distorsion directement)." },
        clarte:     { label: "Clarté",     low: "Flou",         mid: "Correct",  high: "Net",
          what: "Intelligibilité et définition — chaque élément se distingue sans être masqué.",
          how:  "Moyenne des catégories Voix et Instruments." },
        assise:     { label: "Assise basse", low: "Léger",      mid: "Correct",  high: "Solide",
          what: "Poids, tenue et cohésion du bas du spectre (sub, basse, kick).",
          how:  "Dérivé des items de la catégorie Basses & Kick." },
      },
      /* Tooltip mix indicator (copy generique) */
      miTooltipWhat: "Ce qu'il mesure",
      miTooltipHow: "Comment il est calculé",
      miTooltipSource: "Source",
      miTooltipSourceDirect: "Score fourni directement par l'analyse IA",
      miTooltipSourceDerived: "Dérivé du diagnostic",
      miTooltipNoSource: "Aucune catégorie correspondante — fallback sur le score global",
      miTooltipBasedOn: "Basé sur",

      /* DSP visuels (LoudnessMeter, DspMiniCard, VoiceVsInstruBlock,
         StereoFieldBlock) — kickers + zones + verdicts. FR par défaut,
         EN dans le bloc en: ci-dessous. */
      dspViz: {
        // LoudnessMeter (A.1)
        lufsZoneSoft: "Trop sage",
        lufsZoneStreaming: "Streaming",
        lufsZoneTarget: "Compétitif",
        lufsZoneCritical: "Surcomprimé",

        // DspMiniCard LRA (A.2)
        lraKicker: "PLAGE DYNAMIQUE",
        lraZoneCritical: "Écrasée",
        lraZoneStandard: "Standard",
        lraZoneTarget: "Confortable",
        lraZoneSoft: "Large",

        // DspMiniCard True Peak (A.2)
        truePeakKicker: "TRUE PEAK",
        truePeakZoneTarget: "Sous cible",
        truePeakZoneLow: "Risque",
        truePeakZoneCritical: "Clipping",

        // VoiceVsInstruBlock (C.1)
        voiceLabel: "VOIX",
        instruLabel: "INSTRU",
        voiceVerdictTarget: "Voix bien posée ✓",
        voiceVerdictRetreat: "À retravailler — voix en retrait",
        voiceVerdictProminent: "Voix proéminente — choix assumé",

        // StereoFieldBlock — Largeur (C.2)
        widthKicker: "LARGEUR",
        widthZoneNarrow: "Étroit",
        widthZoneStandard: "Standard",
        widthZoneWide: "Large",
        widthZoneVeryWide: "Très large",

        // StereoFieldBlock — Mono Compat (C.2)
        monoCompatKicker: "MONO COMPAT",
        monoCompatZoneOk: "Mono OK",
        monoCompatZoneLimit: "Mono limite",
        monoCompatZoneDanger: "Mono à reprendre",

        // StereoFieldBlock — Corrélation L/R (C.2)
        corrKicker: "CORR L/R",
        corrZonePhaseInv: "Phase inversée",
        corrZoneVeryWide: "Très large",
        corrZoneTarget: "Équilibrée",
        corrZoneNarrow: "Étroite",

        // StereoFieldBlock — Balance bar verdicts (C.2)
        balanceCenter: "centré",
        balanceLeftLeaning: "légèrement à gauche",
        balanceRightLeaning: "légèrement à droite",
        balanceLeftHeavy: "penché à gauche",
        balanceRightHeavy: "penché à droite",
      },

      /* Qualitative / Listening block titles + toggles */
      blockImpression: "Impression",
      blockPointsForts: "Points forts",
      blockATravailler: "À travailler",
      blockEspace: "Espace",
      blockDynamique: "Dynamique",
      blockPotentiel: "Potentiel",
      toggleReduce: "— Réduire",
      toggleExpandListening: "+ Voir l'écoute complète",
      toggleReduceDash: "− Réduire",

      /* AnalyzingState (finalisation) — titre split en 2 pour la charte v2
         (un mot en amber dans un <em>). */
      finalizingTitle: "Finalisation de l'analyse",
      finalizingSubtitle: "La fiche d'analyse se génère. Encore quelques secondes.",
      finalizingTitleBefore: "Finalisation",
      finalizingTitleEm: "en cours",
      finalizingStatus: "Rédaction de la fiche",

      /* VocalTypePill */
      vocalPillVocalTitle: "Morceau chanté — la voix est évaluée",
      vocalPillInstrumentalPending: "Voix à venir",
      vocalPillInstrumentalPendingTitle: "Voix à venir sur les prochaines versions",
      vocalPillInstrumentalFinalTitle: "Œuvre purement instrumentale — la voix n'est pas évaluée",

      /* Membres / collaboration (side panel verdict) */
      membersPrivate: "Privé · inviter",
      membersShared: "{n} membres",
      membersManage: "Gérer les accès",
      /* Timeline actions */
      timelineBackHome: "Accueil",
      timelineShareBtn: "Partager un lien",
      timelineExportBtn: "Exporter en PDF",
      timelineScoreCardBtn: "Score Card",
      timelineShareTitle: "Générer un lien public lecture seule",
      timelineExportTitle: "Générer un PDF partageable de cette version",
      timelineScoreCardTitle: "Télécharger une Score Card carrée pour les réseaux sociaux",
      timelineSavingInProgress: "Enregistrement en cours…",

      /* VersionChat clear + placeholder */
      chatClearTitle: "Effacer la conversation",
      chatClearConfirmTitle: "Effacer la conversation ?",
      chatClearConfirmBody: "La conversation de cette version sera supprimée définitivement.",
      chatClearConfirmLabel: "Effacer",
      chatPlaceholderAnalysis: "…",
      chatFabTitle: "Discussion",
      chatPillPlaceholder: "Demande à Versions…",
      chatRailLabel: "Demander",
      // Affiché pendant la génération du seed mastering (1ère ouverture
      // du chat sur une fiche). Reste 5-15s le temps que /api/mastering-
      // charter retourne sa réponse personnalisée croisée avec la fiche.
      chatSeedingMastering: "Préparation de la charte mastering pour ton track…",

      /* EvolutionPanel */
      evolutionTitle: "Évolution",
      evolutionFromTo: "Évolution {first} → {last}",
      deltaEqualPrev: "= v. préc.",
      statVersionActive: "Version active",
      statDuration: "Durée",

      /* Notes */
      notesTitle: "Mes notes",
      notesTitleV2: "Notes de version",
      notesStatusSaving: "Sauvegarde…",
      notesStatusSaved: "Sauvegardé",
      notesPlaceholder: "Tes observations, rappels, TODOs pour le prochain mix…",
      notesPlaceholderV2: "Tes notes sur cette version…",
      notesPlaceholderDisabled: "Notes disponibles une fois l'analyse sauvegardée.",
      notesClear: "Effacer",
      notesSave: "Enregistrer",

      /* Plan filters + pending voice */
      pendingVoiceStep: "étape à franchir",
      planShowAll: "Tout afficher",
      planHideResolved: "Masquer résolus",
      planShowAllTitle: "Afficher tous les ajustements",
      planHideResolvedTitle: "Masquer les ajustements résolus",
      planResolvedSingular: "résolu",
      planResolvedPlural: "résolus",
      planDetailsHint: "Voir les détails",
      pendingVerdict: "Analyse en cours…",
      translating: "Traduction en cours…",
      genreDeclared: "Genre",
      genreInferred: "Genre détecté pendant l'analyse",
      genreInferredSuffix: "détecté pendant l'analyse",
      genreEditPlaceholder: "Ex : indie pop, néo-soul, dub-techno…",
      genreEditTooltip: "Cliquer pour modifier",
      genreAdd: "+ Ajouter un genre",
      // CTA chat — affiché sur 2 lignes : intro discrète au-dessus,
      // libellé principal en dessous. Ouvre le chat drawer pré-rempli
      // avec la charte mastering (cibles LUFS / true peak / mono / etc.
      // par destination). Le mastering n'est pas notre cœur de métier
      // mais on donne les normes attendues, et l'utilisateur peut
      // creuser dans le chat si besoin.
      diagChatCtaIntro: "Conseils mastering ?",
      diagChatCta: "Parlons-en dans le chat",
      // Release readiness banner — eyebrow + tier labels + subtitles
      releaseEyebrow: "VERDICT DE SORTIE",
      releaseAriaLabel: "État de sortie",
      releaseReady: "Prêt à sortir",
      releaseAlmost: "Presque prêt",
      releaseNotYet: "Pas encore",
      releaseReadySub: "Tu peux la sortir — aucun bloquant détecté.",
      releaseAlmostSubAction: "{count} action{plural} prioritaire{plural} avant de sortir.",
      releaseAlmostSubScore: "Score à consolider avant la sortie.",
      releaseNotYetSubAction: "{count} action{plural} prioritaire{plural} en attente.",
      releaseNotYetSubScore: "Score sous le seuil — encore du chemin avant la sortie.",
      // Variantes "Prêt pour le mastering" — affichées quand la version a
      // été uploadée comme un MIX (toggle Mix/Master à l'upload). Le
      // diagnostic master & loudness reste informatif et ne pénalise pas
      // le score : on parle donc d'un cap "envoyable au mastering" plutôt
      // que d'un cap "envoyable en streaming".
      releaseMasteringEyebrow: "VERDICT DE SORTIE",
      releaseMasteringReady: "Prêt pour le mastering",
      releaseMasteringAlmost: "Presque prêt à masteriser",
      releaseMasteringNotYet: "Pas encore prêt",
      releaseMasteringReadySub: "Tu peux l'envoyer au mastering — aucun bloquant détecté.",
      releaseMasteringAlmostSubAction: "{count} action{plural} prioritaire{plural} avant le mastering.",
      releaseMasteringAlmostSubScore: "Score à consolider avant le mastering.",
      releaseMasteringNotYetSubAction: "{count} action{plural} prioritaire{plural} en attente.",
      releaseMasteringNotYetSubScore: "Score sous le seuil — encore du chemin avant le mastering.",
      // Score Band social (B.3, refonte 2026-05-20) — palier qui situe socialement
      // à côté du verdict de sortie. Option A "Sobre et factuel" tranchée avec
      // David. 6 tiers calés sur le globalScore /100 :
      //   90-100 = référence, 80-89 = hit, 65-79 = pro,
      //   50-64 = démo avancé, 30-49 = en développement, 0-29 = début de parcours.
      // Volontairement sans rouge dans la grille de couleurs : "En développement"
      // et "Début de parcours" sont encourageants, pas punitifs.
      scoreBandAriaLabel: "Niveau du mix",
      scoreBandReference: "Niveau référence",
      scoreBandHit: "Niveau hit",
      scoreBandPro: "Niveau pro",
      scoreBandDemoAdvanced: "Démo avancée",
      scoreBandDeveloping: "En développement",
      scoreBandStart: "Début de parcours",
      // Evolution banner — title + section labels
      evolutionSince: "Évolution depuis {prev}",
      evolutionSinceLast: "Évolution depuis la dernière",
      evolutionAriaLabel: "Évolution depuis la version précédente",
      evolutionProgres: "Progrès",
      evolutionRegressions: "Régressions",
      evolutionPersistants: "Persistants",
      evolutionNouveaux: "Nouveaux",
    },

    /* ─────────────── COMPARE ─────────────── */
    compare: {
      title: "COMPARAISON DE VERSIONS",
      subtitle: "Ce qui a changé entre tes versions",
      pickA: "Version A",
      pickB: "Version B",
      differences: "Différences",
      improvements: "Progrès",
      regressions: "Régressions",
      suggestions: "Suggestions",
      sameScore: "Score identique",
      scoreDelta: "Écart de score",
      noChange: "Pas de changement notable",
      generating: "Comparaison en cours…",
      empty: "Au moins deux versions analysées sont nécessaires pour comparer.",
      otherTitleDetected: "Attention : ces versions semblent être des titres différents.",
      btn: "Comparer",
      btnTitleEnabled: "Comparer à une autre version",
      btnTitleDisabled: "Aucune autre version disponible",
      dropdownKicker: "COMPARER À",
      runningInline: "COMPARAISON EN COURS — {a} VS {b}…",
      errorPrefix: "Erreur",
      headerKicker: "Comparaison",
      colProgress: "Progrès",
      colRegressions: "Régressions",
      colUnchanged: "Inchangé",
    },

    /* ─────────────── CHAT (contextuel fiche) ─────────────── */
    chat: {
      placeholder: "Pose une question sur cette version…",
      placeholderGeneric: "Ta question…",
      send: "Envoyer",
      loading: "L'IA réfléchit…",
      emptyTitle: "Demande ce que tu veux à l'IA",
      emptySub: "Elle a accès à la fiche, à l'analyse audio et à la base PureMix.",
      suggestionLabel: "Suggestions",
      reset: "Nouvelle conversation",
      errorGeneric: "Une erreur est survenue. Réessaie.",
    },

    /* ─────────────── ASK MODAL ─────────────── */
    ask: {
      title: "POSER UNE QUESTION",
      sub: "Expert production musicale · Tous DAWs",
      placeholder: "Ta question…",
      send: "Envoyer",
      thinking: "Réflexion en cours…",
      exampleLabel: "Exemples",
      examples: [
        "Comment mixer une voix R&B chaude ?",
        "Quel compresseur sur la basse pour du rap ?",
        "Comment éviter le muddy dans un mix ?",
      ],
      heroTitle: "ASSISTANT VERSIONS",
      heroSub: "Expert production musicale · Tous DAWs · Base de connaissance active",
      emptyHint: "Tips de production, mixage, plugins,\ntechniques — demande ce que tu veux.",
      noReply: "Pas de réponse.",
      thinkingShort: "Réflexion",
      examplesShort: [
        "Comment bien compresser une voix ?",
        "Réglages EQ pour un kick EDM",
        "Différence entre reverb plate et hall",
        "Meilleur bus master chain",
      ],
    },

    /* ─────────────── FEEDBACK (questionnaire testeurs) ─────── */
    // Modale 6 questions, déclenchée depuis la sidebar (bouton
    // "Ton avis ?") ou la fiche. Volontairement courte pour qu'un
    // testeur la remplisse en moins de 3 min après 2-3 analyses.
    feedback: {
      triggerLabel: "Ton avis compte",
      triggerTitle: "Donne ton avis sur Versions — 3 min, 6 questions",
      title: "Ton avis",
      sub: "6 questions courtes — moins de 3 minutes",
      intro: "Tes retours nous aident à calibrer Versions. Tu peux laisser une question vide si tu n'as rien à dire dessus.",
      // Q1 : NPS
      q1Label: "Sur 0 à 10, recommanderais-tu Versions à un autre artiste qui se mixe seul ?",
      q1Hint: "0 = jamais — 10 = absolument",
      q1Low: "Pas du tout",
      q1High: "Carrément",
      // Q2 : surprise positive
      q2Label: "Qu'est-ce qui t'a le plus surpris dans le diagnostic ?",
      q2Placeholder: "Un point que tu ne soupçonnais pas, une formulation qui a fait mouche…",
      // Q3 : friction
      q3Label: "Y a-t-il un moment où tu t'es dit \"ça je comprends pas\" ou \"ça me sert à rien\" ?",
      q3Placeholder: "Un mot trop technique, un score qui t'a paru injuste, une zone d'ombre…",
      // Q4 : willingness to pay
      q4Label: "Aurais-tu payé pour avoir cette analyse ? À quel prix ça t'aurait paru juste ?",
      q4Placeholder: "Oui / non, et un ordre de prix par analyse ou par mois si tu en as un en tête.",
      // Q5 : verbatim landing
      q5Label: "Si tu devais décrire Versions en une phrase à un pote musicien, tu dirais quoi ?",
      q5Placeholder: "Une phrase, comme tu la dirais à voix haute.",
      // Q6 : priorité
      q6Label: "Une chose à changer ou à ajouter en priorité ?",
      q6Placeholder: "Bug, fonctionnalité manquante, formulation, tarif… ce qui te vient en premier.",
      // Footer
      cancel: "Plus tard",
      submit: "Envoyer mon avis",
      submitting: "Envoi…",
      successTitle: "Reçu — merci.",
      successBody: "C'est précieux. Tes mots vont nourrir la prochaine version.",
      successClose: "Fermer",
      errorTitle: "Envoi impossible",
      errorBody: "Réessaie dans un instant. Si ça persiste, écris-nous à contact@versions.studio.",
      errorRetry: "Réessayer",
      requiredHint: "Au moins une réponse est nécessaire pour envoyer.",
      mustBeSignedIn: "Connecte-toi pour envoyer ton retour.",
    },

    /* ─────────────── VERSIONS SCREEN ─────────────── */
    versions: {
      title: "VERSIONS",
      subtitle: "Tes titres et leurs versions",
      empty: "Aucun titre pour l'instant.",
      emptyCta: "Importer mon premier titre",
      searchPlaceholder: "Rechercher un titre, un projet…",
      filterAll: "Tous",
      filterAnalyzed: "Analysés",
      filterPending: "En attente",
      noResults: "Aucun résultat",
      noResultsSub: "Essaie un autre terme ou réinitialise les filtres",
      sortRecent: "Plus récent",
      sortOldest: "Plus ancien",
      sortAlpha: "A → Z",
      sortScore: "Par score",
      versionsCount: "{n} version",
      versionsCountPlural: "{n} versions",
      latestVersion: "Dernière",
      play: "Écouter",
      openFiche: "Voir l'analyse",
      addVersion: "+ Version",
      menuRename: "Renommer",
      menuDelete: "Supprimer",
      menuChangeProject: "Changer de projet",
      menuChangeVocalType: "Type de titre",
      confirmDeleteTrackTitle: "Supprimer ce titre ?",
      confirmDeleteTrackBody: "Toutes les versions et analyses associées seront supprimées. Cette action est irréversible.",
      confirmDeleteVersionTitle: "Supprimer cette version ?",
      confirmDeleteVersionBody: "L'analyse et le fichier audio liés seront effacés. Cette action est irréversible.",

      /* Mobile / stylised page */
      mobileTitle: "MES TITRES",
      trackSingular: "titre",
      trackPlural: "titres",
      versionSingular: "version",
      versionPlural: "versions",
      emptyMobile: "Aucun titre pour le moment",
      emptyMobileSub: "Lance ta première analyse pour commencer",
      stopAction: "Stop",
      viewFicheCta: "Voir la fiche d'analyse",
      addVersionCta: "Ajouter une version",
    },

    /* ─────────────── SIDEBAR ─────────────── */
    sidebar: {
      sectionTracks: "Titres",
      sectionProjects: "Projets",
      sectionMyProjects: "Mes projets",
      dashboardLink: "Tableau de bord",
      signInLink: "Connexion / inscription",
      newTrack: "+ Nouveau titre",
      newProject: "+ Nouveau projet",
      noTracks: "Aucun titre pour le moment",
      emptyTracks: "Aucun titre pour l'instant",
      menuAddVersion: "Ajouter une version",
      menuRename: "Renommer",
      menuDelete: "Supprimer",
      menuMove: "Déplacer",
      dragProject: "Glisser pour déplacer le projet",
      moveProject: "Déplacer le projet",
      options: "Options",
      expand: "Déplier",
      collapse: "Replier",
      askAi: "Poser une question",
      homeLink: "Accueil",
      settingsLink: "Réglages",
      signOut: "Se déconnecter",
      premiumBadge: "Premium",
      // Affichage du solde sous le nom d'utilisateur. Phase test : tous
      // les comptes démarrent à 999 crédits, la logique de débit/refund
      // n'est pas branchée tant que Stripe n'est pas live.
      creditsLoading: "—",
      creditsSingular: "1 crédit",
      creditsPlural: "{count} crédits",
    },

    /* ─────────────── PLAYER ─────────────── */
    player: {
      idle: "Pas de lecture en cours",
      idleShort: "Aucune lecture",
      idleHint: "Choisis un titre pour l'écouter",
      prev: "Précédent",
      next: "Suivant",
      play: "Lecture",
      pause: "Pause",
      toggle: "Lecture / pause",
      loading: "Chargement…",
      loadingInline: "chargement…",
      noAudio: "Audio indisponible",
      speed: "Vitesse",
      volume: "Volume",
    },

    /* ─────────────── RÉGLAGES (propres au composant) ─────── */
    // Carte « Nouvelles d'Archipel Audio » du tableau de bord (comptes sans
    // choix). Texte versionné toast-fr-2026-10-A (cf. archipelConsent.js +
    // public.archipel_text_versions) : toute modification = nouvelle version.
    archipelToast: {
      aria: "Nouvelles d'Archipel Audio",
      text: "Versions fait partie de la famille Archipel Audio. Tu veux recevoir de temps en temps nos autres outils pour musiciens ?",
      sub: "Par email · désinscription en un clic",
      privacy: "Confidentialité",
      no: "Non merci",
      yes: "Oui, volontiers",
      later: "Plus tard",
    },
    reglages: {
      title: "RÉGLAGES",
      subtitle: "Gérer ton profil et tes préférences",
      sectionAvatar: "PHOTO DE PROFIL",
      sectionProfile: "PROFIL",
      sectionDaw: "DAW PAR DÉFAUT",
      sectionLang: "LANGUE",
      sectionBank: "COORDONNÉES BANCAIRES",
      sectionSecurity: "SÉCURITÉ",
      sectionData: "DONNÉES",
      sectionSubscription: "ABONNEMENT",
      sectionPayment: "PAIEMENT",
      sectionPreferences: "PRÉFÉRENCES",
      avatarHint: "Clique sur l'avatar pour changer ta photo",
      firstName: "PRÉNOM",
      firstNamePlaceholder: "Ton prénom",
      lastName: "NOM",
      lastNamePlaceholder: "Ton nom",
      emailLabel: "EMAIL",
      dawNone: "Aucun (demander à chaque fois)",
      langFrench: "Français",
      langEnglish: "English",
      bankHint: "Ces informations sont chiffrées et utilisées uniquement pour les reversements d'abonnement.",
      bankPremium: "PREMIUM",
      ibanLabel: "IBAN",
      bicLabel: "BIC / SWIFT",
      save: "Enregistrer",
      saving: "Enregistrement...",
      saved: "✓ Enregistré",
      signOut: "Se déconnecter",
      planFree: "5 analyses / mois",
      planCurrent: "PLAN ACTUEL",
      upgrade: "PASSER EN PRO",
      proFeatures: "Analyses illimitées · Export PDF · Assistant enrichi · Historique complet",
      notifNews: "Notifications — Nouveautés",
      dangerZone: "Zone de danger",
      deleteAccount: "Supprimer mon compte",
      exportPdf: "Exporter mes analyses",
      exportPdfDesc: "Télécharger toutes tes fiches en PDF",
      exportData: "Exporter mes données",
      exportDataDesc: "Archive complète au format JSON",
      deleteData: "Supprimer toutes mes données",
      irreversible: "Cette action est irréversible. Toutes tes analyses et préférences seront supprimées.",
      changePhoto: "Changer la photo",
      username: "Nom d'utilisateur",
      noCard: "Aucune carte enregistrée",
      cardRequired: "Requis pour le plan Pro",
      addCard: "Ajouter une carte",
      /* Mini-modal réglages v2 */
      miniHead: "Modale · Réglages",
      miniTitleBefore: "Mes",
      miniTitleEm: "réglages",
      miniEyebrow: "Mon compte",
      miniAccountPlanFree: "Free",
      creditSingular: "crédit",
      creditsPlural: "crédits",
      renewsOn: "Renouv. {date}",
      buyCreditsCta: "Acheter des crédits",
      manageSubscriptionCta: "Gérer mon abonnement",
      miniAvatarLabel: "Photo de profil",
      miniAvatarHint: "Clique pour changer",
      miniProfileLabel: "Nom complet",
      miniProfileHint: "",
      miniLangLabel: "Langue",
      miniLangHint: "",
      miniDawLabel: "DAW par défaut",
      miniDawHint: "Pour des plans d'action ciblés",
      miniBankLabel: "Coordonnées bancaires",
      miniBankHint: "",
      miniAccountLabel: "Compte",
      miniAccountPlanFree: "Free",
      miniAccountPlanPremium: "Premium",
      replayOnboardingLabel: "Guide d'utilisation",
      replayOnboardingHint: "Reprendre le guide étape par étape",
      replayOnboardingBtn: "Revoir",
      // Nouvelles d'Archipel Audio (migration 052) — texte versionné
      // (acct-fr-2026-10-A), cf. src/lib/archipelConsent.js.
      archipelLabel: "Nouvelles d'Archipel Audio",
      archipelHint: "Reçois de temps en temps nos outils pour musiciens (AudioKit, AudioPass, Poll the Band). Désinscription en un clic dans chaque email.",
      archipelYes: "Oui",
      archipelNo: "Non",
      archipelError: "Impossible d'enregistrer ce choix. Réessaie.",
      // Résiliation d'abonnement (visible uniquement si abonné).
      // Branchement Stripe direct (livré 2026-05-31) : confirm modal →
      // POST /api/billing/cancel-subscription → modale de succès.
      // Fallback mailto si l'API échoue ou si stripe_subscription_id
      // est manquant côté DB (bug webhook ancien).
      cancelSubLabel: "Abonnement",
      cancelSubHint: "Résilier ton abonnement actuel",
      cancelSubBtn: "Résilier",
      cancelSubModalTitle: "Résilier l'abonnement",
      cancelSubModalMessage: "Tu gardes l'accès et tes crédits jusqu'à la fin de la période déjà payée. Aucun prélèvement ne sera effectué après cette date. Tu pourras te réabonner à tout moment.",
      cancelSubModalConfirm: "Confirmer la résiliation",
      cancelSubSuccessTitle: "Résiliation enregistrée",
      cancelSubSuccessMessage: "C'est fait. Tu gardes ton accès et tes crédits jusqu'au {date}. À très bientôt !",
      cancelSubSuccessMessageNoDate: "C'est fait. Tu gardes ton accès jusqu'à la fin de ta période actuelle. À très bientôt !",
      // Suppression de compte — bouton danger, modale de confirmation.
      // Côté backend rien n'est branché : la modale invite à envoyer un
      // e-mail au support qui supprimera le compte manuellement.
      deleteAccountLabel: "Supprimer mon compte",
      deleteAccountHint: "Supprime définitivement ton compte et toutes tes données",
      deleteAccountBtn: "Supprimer",
      deleteAccountModalTitle: "Supprimer mon compte",
      deleteAccountModalMessage: "Cette action est irréversible. Pour confirmer, on va t'envoyer un email avec un lien de confirmation. La suppression ne sera effective qu'après ton clic sur ce lien.",
      deleteAccountModalConfirm: "Envoyer l'email de confirmation",
      deleteAccountErrorTitle: "Suppression impossible",
      deleteAccountErrorMessage: "Une erreur est survenue lors de l'envoi de l'email de confirmation. Réessaie dans un instant ou écris-nous à contact@versions.studio si le problème persiste.",
      deleteAccountEmailSentTitle: "Email envoyé",
      deleteAccountEmailSentMessage: "On t'a envoyé un email pour confirmer la suppression. Clique sur le lien pour finaliser. Le lien est valable 1 heure.",
      mailtoCancelSubSubject: "Résiliation de mon abonnement",
      mailtoCancelSubBody: "Bonjour,\n\nJe souhaite résilier mon abonnement Versions.\n\nE-mail du compte : {email}\n\nMerci.",
      close: "Fermer",
    },

    /* ─────────────── AVATAR MENU ─────────────── */
    avatarMenu: {
      premium: "Passer en Premium",
      settings: "Réglages",
      help: "Aide & support",
      logout: "Se déconnecter",
      fallbackUser: "Utilisateur",
      fallbackEmail: "user@example.com",
      planFree: "FREE",
    },

    /* ─────────────── ONBOARDING FIRST PROJECT ─────────────── */
    onboardingFirst: {
      kicker: "Premier pas",
      welcome: "Bienvenue sur VERSIONS.",
      welcomeNamed: "Bienvenue, {name}.",
      body: "Pour commencer, crée ton premier projet. C'est un dossier qui regroupera tes titres (un album, un EP, une session de travail…). Tu pourras en créer d'autres plus tard.",
      projectNameLabel: "Nom du projet",
      projectDefault: "Mon premier projet",
      projectPlaceholder: "Mon premier projet",
      creating: "Création…",
      cta: "Créer mon projet",
      errorGeneric: "Impossible de créer le projet.",
    },

    /* ─────────────── ADD MODAL ─────────────── */
    addModal: {
      title: "Ajouter",
      rootTitleBefore: "Ajouter",
      rootTitleEm: "quoi ?",
      back: "← Retour",
      close: "Fermer",
      cancel: "Annuler",
      choiceNewProjectLabel: "Nouveau projet",
      choiceNewProjectDesc: "Album, EP, session…",
      choiceNewTrackLabel: "Nouveau titre",
      choiceNewTrackDesc: "Dans un projet existant",
      choiceNewTrackDescDisabled: "Crée d'abord un projet",
      choiceAddVersionLabel: "Nouvelle version",
      choiceAddVersionDesc: "D'un titre existant",
      choiceAddVersionDescDisabled: "Crée d'abord un titre",
      pickProjectTitle: "Dans quel projet ?",
      pickTrackTitle: "À quel titre ?",
      createNewProject: "Créer un nouveau projet",
      newProjectStepTitle: "Nom du projet",
      newProjectPlaceholder: "Mon EP, album, etc.",
      newProjectConfirm: "Créer",
      trackSingular: "titre",
      trackPlural: "titres",
      versionSingular: "version",
      versionPlural: "versions",
      // Étape upload
      uploadInProject: "Projet",
      uploadAddVersionTo: "Nouvelle version de",
      uploadMixLabel: "Ton mix",
      uploadDropText: "Dépose le fichier ou clique pour choisir",
      uploadDropFormats: "WAV (recommandé) · MP3 · FLAC · 70 Mo max",
      uploadTitleLabel: "Titre",
      uploadTitlePlaceholder: "Nom du morceau",
      uploadVersionLabel: "Nomme ta version",
      uploadVersionPlaceholder: "v1, rough, master…",
      uploadVocalLabel: "Type de titre",
      uploadVocalSung: "Chanté",
      uploadVocalInstrumental: "Instrumental",
      uploadVocalComing: "Voix à venir",
      uploadVocalFinal: "Définitif",
      // Question "Ce mix a-t-il été masterisé ?" à l'upload (refonte 2026-05-20, C.2 roadmap).
      // 3 options Oui / Non / Auto-detect. Pilote la pondération master & loudness
      // dans le score (Oui : strict, Non / Auto : indulgent) + le verdict de sortie.
      uploadTypeLabel: "Ce mix a-t-il été masterisé ?",
      uploadTypeYes: "Oui",
      uploadTypeNo: "Non",
      uploadTypeMasterConfirmTitle: "Vraiment masterisé ?",
      uploadTypeMasterConfirmMessage: "Tu confirmes que ce fichier est masterisé ? Pas un mix avec un limiteur ou un plugin de mastering posé sur le bus master pour l'écoute, mais le fichier que tu envoies tel quel à Spotify, Apple Music ou ton distributeur — sans plus aucune modification prévue.",
      uploadTypeMasterConfirmYes: "Oui, masterisé",
      uploadTypeMasterConfirmNo: "Non, encore en mix",
      uploadTypeYesHint: "Fichier finalisé et masterisé, plus aucune modification prévue — sera évalué comme un titre prêt à publier.",
      uploadTypeNoHint: "Mix en cours — c'est le défaut. Ton titre est évalué sans exiger les niveaux d'un master fini. Même avec un limiteur ou un plugin de mastering posé sur le bus master pour l'écoute, laisse Non tant que tu fignoles.",
      uploadDawLabel: "Ton DAW",
      uploadDawPlaceholder: "Sélectionne ton DAW…",
      uploadGenreLabel: "Genre musical",
      uploadGenrePlaceholder: "Ex : indie pop, néo-soul, dub-techno…",
      uploadGenreAutoHint: "On détectera le genre pendant l'analyse",
      uploadGenreAutoBtn: "Choisir automatiquement",
      uploadCta: "Lancer l'analyse",
      uploadCtaIncomplete: "Complète les champs pour lancer",
      copyrightAck: "Je détiens les droits sur ce fichier audio ou je suis autorisé à l'analyser sur Versions.",
      uploadBpmLabel: "BPM",
      uploadBpmHint: "Optionnel — laisse vide pour détection automatique.",
      uploadBpmPlaceholder: "ex : 120",
      // Cap durée audio (12 min). Bloque côté navigateur avant POST,
      // double validation côté backend.
      uploadDurationReading: "Lecture du fichier…",
      uploadDurationTooLongTitle: "Fichier trop long",
      uploadDurationTooLongDetail: "Versions analyse les morceaux jusqu'à 12 minutes. Ce fichier dure {dur}.",
      uploadDurationUnreadable: "Format de fichier non lisible. Essaie un autre fichier.",
    },

    /* ─────────────── MODALES ─────────────── */
    modals: {
      // Rename
      renameTitle: "Renommer",
      renamePlaceholder: "Nouveau nom",
      renameConfirm: "Renommer",
      // Confirm
      confirmTitle: "Confirmer l'action",
      confirmDeleteDefault: "Cette action est irréversible. Continuer ?",
      // No credits — bloque l'ajout de titre/version quand le solde est à 0.
      noCreditsTitle: "Plus de crédits",
      noCreditsBody: "Tu n'as plus de crédits d'analyse. Abonne-toi ou achète un pack pour continuer à analyser tes mix.",
      noCreditsCta: "Voir les offres",
      noCreditsCancel: "Plus tard",
      // Add version
      addTitle: "Ajouter une version",
      addVersionName: "Nom de la version",
      addVersionPlaceholder: "ex: Mix v3, Master, Radio Edit…",
      addSubmit: "Ajouter",
      // Share link
      shareTitle: "Partager cette fiche",
      shareSub: "Toute personne avec ce lien pourra consulter la fiche.",
      shareCreate: "Créer un lien public",
      shareRevoke: "Désactiver le lien",
      shareCopy: "Copier le lien",
      shareCopied: "Lien copié !",
      shareModalTitle: "Partager un lien public",
      shareTitleBefore: "Lien",
      shareTitleEm: "public",
      shareSubPrefix: "Pour",
      shareVersionPrefix: "Version",
      shareLoading: "Chargement…",
      shareActiveBody: "Lien actif. Toute personne avec cette URL pourra consulter la fiche en lecture seule (aucune connexion requise). Vous pouvez le désactiver à tout moment.",
      shareStatusActive: "Actif",
      shareCopyShort: "Copier",
      shareCopiedShort: "Copié",
      shareDisable: "Désactiver",
      shareClose: "Fermer",
      shareInactiveBody: "Génère une URL unique pour cette version. Toute personne ayant le lien pourra consulter la fiche en lecture seule (aucune connexion requise). Aucune autre version, projet ou notes externes ne sont exposés. Le lien peut être désactivé à tout moment.",
      shareCancel: "Annuler",
      shareEnable: "Activer le lien",
      shareEnabling: "Activation…",
      // Export PDF
      exportPdfTitle: "Exporter en PDF",
      exportPdfSub: "Choisis le niveau de détail.",
      exportPdfFull: "Fiche complète",
      exportPdfSummary: "Résumé (1 page)",
      exportPdfDownload: "Télécharger",
      exportPdfGenerating: "Génération du PDF…",
      exportPdfModalTitle: "Exporter la fiche en PDF",
      exportPdfEyebrow: "Export PDF",
      exportPdfTitleBefore: "Exporter en",
      exportPdfTitleEm: "PDF",
      exportPdfSubPrefix: "Pour",
      exportPdfVersionPrefix: "Version",
      exportPdfSections: "Sections à inclure",
      exportPdfOptListeningLabel: "Section Écoute",
      exportPdfOptListeningHint: "Impression, points forts, à travailler…",
      exportPdfOptDiagnosticLabel: "Diagnostic",
      exportPdfOptDiagnosticHint: "Notes et détails par catégorie",
      exportPdfOptPlanLabel: "Plan d'action",
      exportPdfOptPlanHint: "Ajustements priorisés",
      exportPdfOptNotesLabel: "Notes",
      exportPdfOptNotesHint: "Vos remarques personnelles sur la fiche",
      exportPdfNotAvailable: "— non renseigné",
      exportPdfCancel: "Annuler",
      exportPdfExport: "Exporter",
      exportPdfGeneratingShort: "Génération…",
      // Onboarding
      onboardingWelcome: "Bienvenue sur VERSIONS",
      onboardingSub: "Analyse, compare et fais évoluer tes productions.",
      onboardingStart: "Commencer",
      onboardingSkip: "Passer",
      onboardingStep1Title: "Upload ton mix",
      onboardingStep1Body: "Envoie ton fichier audio — l'IA fait le reste.",
      onboardingStep2Title: "Lis ta fiche",
      onboardingStep2Body: "Diagnostic détaillé, points forts, lacunes, plan d'action.",
      onboardingStep3Title: "Compare tes versions",
      onboardingStep3Body: "Trace l'évolution de chaque morceau version après version.",
      // Vocal type banner
      vocalBannerTitle: "Ce titre est-il chanté ou instrumental ?",
      vocalBannerBody: "Pour affiner l'analyse et ne pas traiter l'absence de voix comme un défaut à tort.",
      vocalBannerConfirm: "Confirmer",
      vocalBannerLater: "Plus tard",
      vocalSuggestAria: "Suggestion de type vocal",
      vocalSuggestTitle: "On a entendu de la voix sur cette version",
      vocalSuggestBody: "Ce titre est encore marqué « Voix à venir ». Le passer en « Chanté » ?",
      vocalSuggestAccept: "Oui, passer en Chanté",
      vocalSuggestDismiss: "Non merci",
    },

    /* ─────────────── VCHIP (pastille de version) ─────────── */
    vchip: {
      optionsTitle: "Options de la version",
      confirmDeleteTitle: "Supprimer la version ?",
      confirmDeleteBody: 'Voulez-vous supprimer la version "{name}" ? Cette action est définitive.',
      confirmDeleteConfirm: "Supprimer",
      menuRename: "Renommer",
      menuDelete: "Supprimer",
      renameVersionTitle: "Renommer la version",
      renameVersionPlaceholder: "Nom de la version",
      renameSubmit: "Renommer",
    },

    /* ─────────────── PUBLIC FICHE (hors app) ───────────── */
    publicFiche: {
      headerShared: "Fiche partagée",
      headerPoweredBy: "Propulsé par",
      cta: "Essaie VERSIONS",
      ctaSub: "Crée ton compte et analyse tes propres titres.",
      expired: "Ce lien n'est plus actif.",
      notFound: "Fiche introuvable.",
      loading: "Chargement de la fiche…",
      notFoundTitle: "Lien introuvable",
      notFoundBody: "Ce lien de partage n'est plus actif, ou il a été désactivé par son propriétaire.",
      notFoundHome: "Retour à l'accueil",
      topbarCta: "Découvrir Versions",
      verdictFallback: "Fiche",
      versionPrefix: "Version {name}",
      footerText: "Fiche générée avec Versions · lecture seule",
      artistNotesTitle: "Notes de l'artiste",
    },

    /* ─────────────── COMMENTAIRES (collaboration) ──────────────── */
    comments: {
      title: "Commentaires",
      subtitle: "Échange avec tes collaborateurs sur cette version.",
      empty: "Aucun commentaire pour l'instant.",
      placeholder: "Écris un commentaire…",
      send: "Commenter",
      sending: "Envoi…",
      signInToComment: "Connecte-toi pour laisser un commentaire.",
      signInCta: "Se connecter",
      resolve: "Marquer résolu",
      unresolve: "Rouvrir",
      resolved: "Résolu",
      deleteLabel: "Supprimer",
      deleteConfirm: "Supprimer ce commentaire ?",
      you: "Toi",
      countOne: "{n} commentaire",
      countMany: "{n} commentaires",
      hideResolved: "Masquer les résolus",
      showResolved: "Afficher les résolus",
      anchorLabel: "Partie concernée",
      anchorAll: "Général",
      filterAll: "Tout",
      liveHere: "en ce moment",
    },

    /* ─────────────── PARTAGE / MEMBRES (collaboration) ──────────────── */
    share: {
      title: "Membres du projet",
      subtitle: "Invite des collaborateurs et gère leurs accès.",
      scopeLabel: "Partager :",
      scopeProject: "Projet entier",
      scopeTrackPrefix: "Titre :",
      inviteEmailLabel: "Inviter par email",
      emailPlaceholder: "email@exemple.com",
      messagePlaceholder: "Message (facultatif) — un mot pour la personne invitée…",
      inviteBtn: "Inviter",
      inviteSent: "Invitation envoyée.",
      inviteError: "L'envoi a échoué.",
      linkTitle: "Lien d'invitation",
      generateLink: "Générer un lien",
      linkCopied: "Lien copié dans le presse-papiers.",
      linkHint: "Quiconque a ce lien et se connecte rejoint le projet.",
      membersTitle: "Membres",
      pendingTitle: "Invitations en attente",
      remove: "Retirer",
      close: "Fermer",
      roles: {
        owner: "Propriétaire",
        editor: "Éditeur",
        commenter: "Commentateur",
        viewer: "Lecteur",
      },
    },

    /* ─────────────── INVITATION / REJOINDRE ──────────────── */
    join: {
      loading: "Chargement de l'invitation…",
      title: "Invitation à collaborer",
      intro: "On t'invite à rejoindre {project}, en tant que :",
      joinBtn: "Rejoindre le projet",
      joining: "On te connecte…",
      signInPrompt: "Connecte-toi ou crée un compte pour rejoindre.",
      home: "Retour à l'accueil",
      invalidTitle: "Invitation invalide",
      invalidGeneric: "Cette invitation n'est plus valide.",
      invalid: {
        not_found: "Ce lien d'invitation est introuvable.",
        expired: "Cette invitation a expiré.",
        used: "Cette invitation a déjà été utilisée.",
      },
      errorGeneric: "Impossible de rejoindre ce projet.",
      errors: {
        auth_required: "Connecte-toi pour rejoindre.",
        expired: "Cette invitation a expiré.",
        used: "Cette invitation a déjà été utilisée.",
        not_found: "Invitation introuvable.",
        failed: "Une erreur est survenue, réessaie.",
      },
    },

    /* ─────────────── ERREURS / MESSAGES ──────────────── */
    errors: {
      generic: "Une erreur est survenue.",
      network: "Connexion interrompue. Vérifie ta connexion internet.",
      uploadFailed: "L'envoi du fichier a échoué.",
      analysisFailed: "L'analyse a échoué. Réessaie dans un instant.",
      fileTooBig: "Fichier trop volumineux (70 Mo max).",
      fileType: "Format non supporté. Utilise WAV, MP3 ou FLAC.",
      requiredField: "Ce champ est obligatoire.",
      invalidEmail: "Email invalide.",
      weakPassword: "Mot de passe trop court (6 caractères min.).",
      loadProfile: "Impossible de charger ton profil.",
      saveProfile: "Impossible d'enregistrer tes modifications.",
      projectCreate: "La création a échoué, réessaye.",
      compareNeedsFiches: "Les deux versions doivent avoir une fiche analysée",
      // Échec de sauvegarde côté front après une analyse réussie côté serveur.
      // Affiché à l'utilisateur si saveAnalysis a échoué (RLS, réseau, session
      // expirée, etc.) — il a perdu visuellement sa fiche, on doit le rassurer
      // et lui rendre le crédit immédiatement via RPC refund_my_failed_analysis.
      saveFailedTitle: "Sauvegarde impossible",
      saveFailedMessageRefunded: "Ton analyse a bien tourné mais on n'a pas réussi à la sauvegarder. Ton crédit a été restitué automatiquement, tu peux réessayer.",
      saveFailedMessageManual: "Ton analyse a bien tourné mais on n'a pas réussi à la sauvegarder. Si ton crédit a été débité, écris-nous à contact@versions.studio, on te le rend.",
      saveFailedOk: "OK",
    },

    /* ─────────────── DATE / TIME ─────────────────────── */
    datetime: {
      today: "Aujourd'hui",
      yesterday: "Hier",
      daysAgo: "Il y a {n} jours",
      weeksAgo: "Il y a {n} semaines",
      monthsAgo: "Il y a {n} mois",
      justNow: "À l'instant",
      minutesAgo: "Il y a {n} min",
      hoursAgo: "Il y a {n} h",
      months: [
        "janv", "févr", "mars", "avr", "mai", "juin",
        "juil", "août", "sept", "oct", "nov", "déc",
      ],
      monthsLong: [
        "janvier", "février", "mars", "avril", "mai", "juin",
        "juillet", "août", "septembre", "octobre", "novembre", "décembre",
      ],
    },

    /* ─────────────── PRICING ─────────────── */
    pricing: {
      // Topbar
      topbarHome: "Accueil",
      topbarCurrent: "Tarifs",
      topbarBackAria: "Retour à l'accueil",

      // Hero
      heroEyebrow: "Tarifs",
      heroTitleStart: "Paie ce que ",
      heroTitleEm: "tu mixes",
      heroTitleEnd: ".",
      heroSub: "Une analyse à l'unité, un pack pour creuser un projet, ou un abonnement dès que tu mixes en série. Pas d'engagement caché.",
      // Chips décoratifs du hero — termes génériques (pas de noms de packs/abos)
      heroChip1: "À LA CARTE",
      heroChip2: "ABONNEMENT",
      heroChip3: "CRÉDITS À VIE",
      heroChip4: "À TON RYTHME",
      heroChip5: "SUR MESURE",

      // Erreurs checkout
      errCheckoutNotConfigured: "Cette offre n'est pas encore configurée. Réessaie dans un instant.",
      errCheckoutPrefix: "Erreur de paiement : ",
      errUnknown: "inconnue",

      // À la carte (packs)
      packsEyebrow: "À la carte",
      packsTitleStart: "Une analyse, un pack, ",
      packsTitleEm: "aucun engagement",
      packsTitleEnd: ".",
      packsLede: "Tu achètes au moment où tu en as besoin, tes crédits ne périment jamais.",
      packAnalysisSingular: "Analyse",
      packAnalysisPlural: "Analyses",
      packPerUnit: "€/analyse",
      packBuy: "Acheter",
      packRedirecting: "Redirection…",

      // Ribbons (résolus depuis plan.highlightKey)
      ribbons: {
        mostChosen: "Le plus choisi",
        cheapestPerUnit: "Le moins cher /unité",
        recommended: "Recommandé",
      },

      // Bandeau "tout est inclus"
      includedLabel: "Inclus dans toutes les analyses",
      included1: "Fiche complète",
      included2: "Chat contextuel",
      included3: "Comparaison de versions",
      included4: "Export PDF + Score Card PNG",
      included5: "Suivi d'évolution",

      // Abonnements
      subsEyebrow: "Abonnements",
      subsTitleStart: "Quand l'analyse devient un réflexe, ",
      subsTitleEm: "abonne-toi",
      subsTitleEnd: ".",
      subsLede: "Enveloppe mensuelle, meilleur prix unitaire, résiliable à tout moment.",
      subsPluginPerk: "Et dans le plugin : écoute express + chat IA en illimité.",
      subAllowanceLine1: "analyses",
      subAllowanceLine2: "par mois",
      subPerMonth: "/mois",
      subUnitLine: "soit {price} €/analyse",
      subChoose: "Choisir",
      // Descriptions des abonnements indexées par plan.key
      subDescriptions: {
        sub_indie: "12 analyses par mois, cumulables tant que ton abonnement est actif.",
        sub_pro: "30 analyses par mois, cumulables tant que ton abonnement est actif. Pour artistes en cycle de production.",
      },

      // École / centres de formation
      schoolEyebrow: "Écoles & centres de formation",
      schoolTitleStart: "Pour les ",
      schoolTitleEm: "structures",
      schoolTitleEnd: ", on ajuste sur devis.",
      schoolLede: "Comptes équipe, accompagnement pédagogique, tarifs ajustés selon le volume.",
      schoolCardLabel: "École",
      schoolCardPrice: "Sur devis",
      schoolCardHint: "Tarifs sur volume",
      schoolMailSubject: "Versions — partenariat école / centre de formation",
      schoolCta: "Nous contacter",

      // FAQ
      faqEyebrow: "Questions fréquentes",
      faqTitleStart: "Avant de te lancer, ",
      faqTitleEm: "tu peux tout savoir",
      faqTitleEnd: ".",
      faq1Q: "Mes crédits expirent-ils ?",
      faq1A: "Les crédits achetés en pack n'expirent jamais. Les crédits abo se cumulent tant que ton abonnement est actif (pas de reset mensuel), mais ils disparaissent à la résiliation — les crédits pack, eux, restent. Tes fiches déjà générées restent à vie dans ton dashboard.",
      faq2Q: "Puis-je cumuler un pack et un abonnement ?",
      faq2A: "Oui. Les crédits d'un pack restent disponibles en plus de ton enveloppe mensuelle. On consomme d'abord l'enveloppe abo, puis les crédits du pack — tu ne perds rien.",
      faq3Q: "Puis-je résilier mon abonnement à tout moment ?",
      faq3A: "Oui, sans frais. La résiliation prend effet à la fin du mois en cours. Tes fiches déjà générées restent accessibles à vie dans ton dashboard, même après résiliation.",
      faq4Q: "Que se passe-t-il si une analyse échoue ?",
      faq4A: "Aucun crédit n'est débité quand une analyse n'aboutit pas. Si on a déjà commencé à débiter et qu'une étape plante, le crédit est restauré automatiquement et tu peux relancer.",
      faq5Q: "Y a-t-il une limite de durée par fichier audio ?",
      faq5A: "Oui, 12 minutes maximum par fichier. C'est largement suffisant pour un titre, et ça nous permet de garantir des prix bas en maîtrisant les coûts d'analyse.",
      faq6Q: "Les tarifs sont-ils HT ou TTC ?",
      faq6A: "Tous les prix affichés sont TTC (TVA française incluse). Une facture conforme est générée automatiquement après chaque achat.",

      // Footer
      footerLine: "Une question avant de te lancer ?",
    },

    /* ─────────────── LANDING ─────────────── */
    landing: {
      // CTAs (par défaut visiteur — App.jsx peut surcharger pour utilisateur connecté)
      ctaPrimary: "Analyser mon premier titre",
      ctaSample: "Voir un exemple",
      ctaFooter: "Analyser mon premier titre",
      // Badge incitatif au-dessus du CTA hero — visible UNIQUEMENT pour les
      // visiteurs non connectés (cf. isAuthenticated dans LandingScreen).
      // Vise à lever la friction "ça coûte combien ?" avant le clic CTA.
      freeFirstBadge: "Première analyse offerte",
      // Version courte pour le badge coin de bouton (grammaire .lp-new-badge)
      freeFirstBadgeShort: "1 analyse offerte",

      // Mockup carte 1 — Score global
      mockScoreEyebrow: "SCORE GLOBAL",
      mockScoreTag: "Mix solide",
      mockScoreBar1: "Équilibre",
      mockScoreBar2: "Dynamique",
      mockScoreBar3: "Stéréo",
      mockScoreBar4: "Saturation",

      // Mockup carte 2 — Diagnostic
      mockDiagEyebrow: "DIAGNOSTIC",
      mockDiagTag: "VOIX",
      mockDiagTitle: "La voix lead manque de présence dans les médiums.",
      mockDiagHowLabel: "ACTION",
      mockDiagHowText: "Boost +2 dB autour de 3 kHz, Q ≈ 1.2 — pour faire ressortir la voix sans la rendre agressive.",
      mockDiagPlugin: "EQ paramétrique",
      mockDiagCheck: "Appliqué",

      // Mockup carte 3 — Évolution V1→V2
      mockEvoEyebrow: "ÉVOLUTION",
      mockEvoUnit: "pts",
      mockEvoText: "Voix mieux placée, basses plus maîtrisées, image stéréo équilibrée.",

      // Mockup conversation IA — variante alternative aux 3 cartes
      chatHead: "MA VOIX — REFRAIN",
      chatVersionPill: "V2",
      chatUserQ1: "Pourquoi le refrain ne décolle pas ?",
      chatScoreImpact: "Voix : 74 → 82 estimé",
      chatUserQ2: "Et la V2 par rapport à la V1 ?",
      chatEvoDelta: "+7 pts",
      chatEvoSummary: "Voix mieux placée, basses plus maîtrisées.",

      // Mockup "constellation de chips" — variante mini-éléments décoratifs
      chip1: "SCORE 82/100",
      chip2: "MIX SOLIDE",
      chip3: "VOIX · +2 dB @ 3 kHz",
      chip4: "EQ PARAMÉTRIQUE",
      chip5: "↑ +7 PTS · V1→V2",
      chip6: "INTENTION : POP ÉNERGIQUE",
      chip7: "BASSES MAÎTRISÉES",

      // Hero — slogan + tagline-trio + sous-titre
      sloganPart1: "Votre",
      sloganEm: "assistant",
      sloganPart2: "de studio",
      taglineBefore: "écoute,",
      taglineEm: "comprend",
      taglineAfter: ", guide.",
      heroSub: "Versions écoute votre musique, comprend votre intention, et vous guide pour améliorer votre mix.",

      // Section "ce qui nous rend différents"
      diffEyebrow: "NOS ATOUTS",
      diffTitleStart: "Pas un rapport.",
      diffTitleEm: "Un dialogue.",
      diffCard1Title: "Un assistant son qui vous connaît",
      diffCard1Body: "Le chat contextuel illimité — pas un rapport statique. Posez toutes vos questions, demandez les détails, contestez l'analyse. Versions garde le fil de votre projet, version après version.",
      diffCard2Title: "Votre intention en premier",
      diffCard2BodyBefore: "On ne juge pas votre morceau dans l'absolu. L'analyse est calibrée sur ce que ",
      diffCard2BodyEm: "vous",
      diffCard2BodyAfter: " cherchez : l'émotion, le genre, le rendu sonore visé. Vos références deviennent la boussole.",
      diffCard3Title: "Des recommandations applicables",
      diffCard3Body: "Pas de \"votre haut médium est un peu chargé\". Des valeurs techniques concrètes, des plages de fréquences, des plugins adaptés à votre DAW. Vous repartez avec un plan d'action.",
      diffCard4Title: "Le suivi par versions",
      diffCard4Body: "V1, V2, V3… Versions garde la mémoire de chaque itération. La progression est mesurée — vous voyez ce qui s'améliore et ce qui reste à creuser, sans repartir à zéro à chaque mix.",
      diffCard5Title: "Des fiches qui se travaillent à plusieurs",
      diffCard5Body: "Partagez une fiche d'analyse à votre réalisateur, votre label ou un autre artiste : chacun son rôle, chacun ses commentaires. Les retours restent posés au bon endroit — sur l'analyse, pas éparpillés dans des messages.",
      diffCard6Title: "En ligne et au cœur de votre DAW",
      diffCard6Body: "L'analyse complète sur le site, et un plugin qui vit dans votre session : metering, conseils et écoute express pendant que vous produisez. Le même assistant, du premier réglage à la version finale.",

      // Section "ce qu'on analyse"
      axesEyebrow: "CE QU'ON ANALYSE",
      axesTitleStart: "Six axes,",
      axesTitleEm: "une écoute complète.",
      axesLede: "Chaque axe combine une analyse DSP objective et un jugement IA calibré sur votre intention. Aucune note n'est posée sans justification.",
      axe1Label: "Équilibre fréquentiel",
      axe1Desc: "Bas, médiums, aigus — pondération entre les bandes, masquages, courbe globale.",
      axe2Label: "Dynamique",
      axe2Desc: "Facteur de crête, plage dynamique, transitoires, gestion de la compression.",
      axe3Label: "Image stéréo",
      axe3Desc: "Largeur, mono-compatibilité, équilibre L/R, placement des éléments.",
      axe4Label: "Espace et profondeur",
      axe4Desc: "Réverbérations, delays, plans avant/arrière, lecture spatiale du mix.",
      axe5Label: "Cohérence globale",
      axe5Desc: "Tenue d'ensemble, fluidité entre sections, identité sonore.",
      axe6Label: "Voix",
      axe6Desc: "Intelligibilité, présence, sibilances, intégration au reste du mix.",

      // Section "ce qu'on ne fait pas"
      nopeEyebrow: "CE QU'ON NE FAIT PAS",
      nopeTitleEm: "Honnête",
      nopeTitleAfter: " sur nos limites.",
      nope1: "On ne dicte pas vos arrangements. La structure, les choix créatifs, le parti-pris artistique — c'est votre territoire.",
      nope2: "On ne remplace pas un ingé son humain. On rend l'expertise accessible quand elle ne l'était pas — pour préparer votre prochain rendez-vous studio, pas pour l'éviter.",
      nope3: "Le score n'est pas une vérité absolue. C'est un repère, calibré sur votre intention, pas un verdict.",

      // Footer
      footerQuoteStart: "Votre musique.",
      footerQuoteEm: "Votre vision.",
      footerQuoteEnd: "Notre accompagnement.",

      // ── Plugin DAW — intégration home (topbar + CTA hero + section) ──
      // Faits sourcés depuis versions-plugin/CLAUDE.md (2026-07) :
      // AU + VST3, macOS + Windows, express-only (l'analyse complète vit
      // sur le site), gratuit = metering illimité + 5 écoutes express/mois
      // + 15 messages chat/jour, illimité avec les abos Indie/Pro.
      pluginNav: "Plugin",
      pluginNewBadge: "Nouveau",
      ctaPlugin: "Découvrir le plugin",
      plugEyebrow: "LE PLUGIN",
      plugTitleStart: "Votre assistant,",
      plugTitleEm: "directement dans votre session.",
      plugLede: "Metering pro gratuit et illimité, chat qui entend votre session, verdict d'écoute en 30 secondes. Et pour la fiche complète, versions.studio vous attend.",
      plugVideoNote: "Vidéo de démo",
      plugPoint1Title: "Metering temps réel, gratuit et illimité",
      plugPoint1Body: "LUFS, true peak, spectre, image stéréo — pendant que vous mixez, 100 % local.",
      plugPoint2Title: "Un assistant IA qui entend votre mix",
      plugPoint2Body: "Posez une question : la réponse s'appuie sur vos mesures en direct et sur les plugins que vous possédez — pas sur des généralités.",
      plugPoint3Title: "Une instance par piste, une vue d'ensemble",
      plugPoint3Body: "Le plugin voit toute votre session : détection de masquage, équilibres entre pistes, et des conseils qui tiennent compte de tout ce qui joue.",
      plugPoint4Title: "L'écoute express",
      plugPoint4Body: "30 secondes d'écoute, un verdict direct dans le chat — sur votre mix ou sur une seule piste. 5 offertes chaque mois, illimitées avec l'abonnement.",
      plugCtaDownload: "Télécharger gratuitement",
    },

    /* ─────────────────────── PAGE PLUGIN (/plugin) ───────────────────
     * Page dédiée au plugin DAW. Même grammaire éditoriale que la
     * landing (vouvoiement, em ambre, mono uppercase pour les eyebrows).
     */
    pluginPage: {
      topbarHome: "Accueil",
      topbarCurrent: "Plugin",
      topbarBackAria: "Retour à l'accueil",
      heroChip1: "-14.2 LUFS",
      heroChip2: "SCORE 82/100",
      heroChip3: "TRUE PEAK -1.1 dB",
      heroChip4: "SESSION · 5 PISTES",
      heroTitleLine1: "Votre assistant,",
      heroTitleLine2Before: "dans ",
      heroTitleLine2Em: "votre DAW",
      heroTitleLine2After: ".",
      taglineBefore: "écoute, ",
      taglineEm: "comprend",
      taglineAfter: ", guide — pendant que vous mixez.",
      heroSub: "Le plugin VERSiONS vit dans votre session : il mesure en temps réel, répond à vos questions en s'appuyant sur ce qu'il entend, et vous donne un verdict d'écoute en 30 secondes — sans rien exporter.",
      chipFree: "GRATUIT",
      ctaMac: "Télécharger pour Mac",
      ctaWin: "Télécharger pour Windows",
      ctaWinSoon: "Windows — bientôt disponible",
      ctaComingSoon: "Lien de téléchargement à venir",
      ctaAuthNote: "Téléchargement avec un compte gratuit — le plugin vous demandera de vous connecter à l'ouverture.",
      videoNote: "Vidéo de démo",
      howEyebrow: "COMMENT ÇA MARCHE",
      howTitleStart: "Trois gestes, ",
      howTitleEm: "zéro export.",
      step1Title: "Posez-le sur vos pistes, vos bus",
      step1Body: "Master, basse, voix, etc. — une instance par piste. Le metering démarre tout seul, et les instances se voient entre elles.",
      step2Title: "Demandez ce que vous voulez",
      step2Body: "« Ma basse masque mon kick ? » Le plugin lit toute votre session et vous répond sur votre mix, pas en théorie.",
      step3Title: "Lancez une écoute express",
      step3Body: "30 secondes d'écoute, un verdict clair dans le chat. Et pour la fiche complète, votre compte versions.studio est déjà relié.",
      featEyebrow: "CE QU'IL SAIT FAIRE",
      featTitleStart: "Il ne mixe pas à votre place. ",
      featTitleEm: "Il vous apprend à mixer.",
      feat1Tag: "Gratuit · illimité",
      feat1Title: "Metering temps réel",
      feat1Body: "LUFS, true peak, plage dynamique, spectre de niveau pro, image stéréo avec corrélation et largeur. Les chiffres qui comptent, lisibles d'un coup d'œil, 100 % local.",
      feat2Tag: "Inclus",
      feat2Title: "Session View",
      feat2Body: "Une instance par piste, et le plugin voit toute votre console : détection de masquage calibrée, spectres superposés, conseils inter-pistes. Personne d'autre ne le fait en dialogue.",
      feat3Tag: "15 messages/jour offerts",
      feat3Title: "Chat en contexte",
      feat3Body: "Vous demandez, il répond — en s'appuyant sur vos mesures en direct et sur ce qui joue dans votre session. En français ou en anglais.",
      feat4Tag: "5/mois offertes",
      feat4Title: "Écoute express",
      feat4Body: "Le plugin écoute 30 secondes de votre mix — ou d'une seule piste — et vous rend un verdict clair dans le chat. Illimitée avec les abonnements Indie et Pro.",
      feat5Tag: "Inclus",
      feat5Title: "Il connaît votre arsenal",
      feat5Body: "Le plugin scanne les plugins installés sur votre ordinateur, et vous choisissez lesquels comptent. Les recommandations citent vos EQ et vos compresseurs — pas des outils que vous n'avez pas.",
      feat6Tag: "Inclus",
      feat6Title: "Calibré sur votre setup",
      feat6Body: "Votre DAW favori, votre système d'écoute — casque ou enceintes de monitoring —, votre niveau : renseignez vos réglages une fois, et chaque réponse en tient compte.",
      featNote: "Abonné Indie ou Pro ? Écoute express et chat en illimité dans le plugin. Et l'analyse complète — score, diagnostic élément par élément, verdict de sortie — vit sur versions.studio, reliée à votre compte.",
      footerQuoteStart: "Votre musique. ",
      footerQuoteEm: "Votre vision.",
      footerQuoteEnd: "Notre accompagnement — jusque dans votre DAW.",
      ctaFooterDownload: "Télécharger le plugin",
      backToHome: "Retour à l'accueil",
    },

    /* ─────────────────────── PAGES LÉGALES ───────────────────
     * Sections de prose pour PrivacyScreen et TermsScreen.
     * Chaque bloc est { type: 'p', text } ou { type: 'ul', items[] }.
     * Markup inline supporté dans `text` / `items[i]` :
     *   - **gras** → <strong>
     *   - {email}  → mailto vers contact@versions.studio
     * (cf. `renderLegalInline` dans components/LegalLayout.jsx)
     * ─────────────────────────────────────────────────────── */
    legal: {
      common: {
        backToHome: "Retour à l'accueil",
        privacyLink: "Politique de confidentialité",
        termsLink: "Conditions générales d'utilisation",
        navAria: "Pages légales",
      },
      privacy: {
        eyebrow: "CONFIDENTIALITÉ",
        title: "Politique de",
        titleEm: "confidentialité",
        updated: "Dernière mise à jour : 20 octobre 2026",
        lede: "La présente politique décrit comment Versions collecte, utilise et protège vos données personnelles lorsque vous utilisez le service accessible à l'adresse www.versions.studio.",
        sections: [
          {
            title: "1. Identité de l'éditeur",
            blocks: [
              { type: 'p', text: "Le service Versions est édité par **Archipel Audio** ({archipel}), société par actions simplifiée (SAS) immatriculée en France sous le numéro SIRET 108 042 102 00013." },
              { type: 'p', text: "Contact : {publisherEmail}" },
            ],
          },
          {
            title: "2. Données collectées et finalités",
            blocks: [
              { type: 'p', text: "Nous collectons uniquement les données nécessaires au fonctionnement du service :" },
              { type: 'ul', items: [
                "**Adresse e-mail** — transmise par Google lors de l'authentification OAuth, utilisée pour identifier votre compte et vous envoyer les communications relatives au service.",
                "**Fichiers audio** — les pistes que vous importez pour analyse (mix ou master) sont stockées sur Supabase Storage afin de permettre leur lecture, leur analyse par notre moteur et l'affichage de vos fiches d'analyse.",
                "**Données d'analyse** — résultats produits par le moteur d'analyse (scores, diagnostics, métriques DSP), conservés pour vous permettre de consulter et comparer vos versions dans le temps.",
                "**Empreinte technique des fichiers audio** — conservée pour des besoins opérationnels (cohérence d'analyse, optimisation des ressources). Supprimée à la suppression de votre compte.",
                "**Préférences utilisateur** — DAW utilisé, langue d'interface, intentions artistiques, paramètres de votre profil.",
                "**Données de paiement** — gérées intégralement par Stripe ; nous ne stockons aucune donnée bancaire sur nos serveurs. Stripe nous communique uniquement le statut des transactions (réussite, échec, abonnement actif).",
                "**Nouvelles d'Archipel Audio** — Archipel Audio, éditeur de Versions, peut utiliser votre adresse e-mail pour vous présenter de temps en temps ses autres outils pour musiciens (AudioKit, AudioPass, Poll the Band). Vous pouvez refuser dès l'inscription, à tout moment depuis vos Réglages, ou en un clic dans chaque email. Nous conservons la preuve de votre choix (version du texte affiché, date, éventuelle opposition).",
              ]},
            ],
          },
          {
            title: "3. Base légale du traitement",
            blocks: [
              { type: 'p', text: "Les traitements sont fondés sur :" },
              { type: 'ul', items: [
                "**L'exécution du contrat** qui vous lie à Versions lorsque vous créez un compte et utilisez le service (article 6.1.b du RGPD) — c'est la base légale principale pour la gestion du compte, le stockage des fichiers audio et la génération des analyses.",
                "**Votre consentement** (article 6.1.a du RGPD) pour l'authentification via Google, recueilli au moment de la connexion OAuth.",
                "**L'intérêt légitime** d'Archipel Audio à vous présenter des produits analogues à Versions (article 6.1.f du RGPD et article L34-5 du Code des postes et des communications électroniques) pour les nouvelles d'Archipel Audio, sauf refus de votre part — ou **votre consentement** si vous les avez activées vous-même depuis vos Réglages.",
                "**Les obligations légales** applicables à l'éditeur (article 6.1.c), notamment en matière comptable et fiscale pour les transactions Stripe.",
              ]},
            ],
          },
          {
            title: "4. Hébergement et sous-traitants",
            blocks: [
              { type: 'p', text: "Vos données peuvent être traitées par nos prestataires techniques : hébergement (Union européenne et États-Unis), paiement, authentification et analyse. La liste détaillée est disponible sur demande à {email}." },
            ],
          },
          {
            title: "5. Durée de conservation",
            blocks: [
              { type: 'ul', items: [
                "**Compte utilisateur, fichiers audio et analyses** — conservés tant que votre compte est actif, puis 30 jours après la suppression du compte. Vous pouvez supprimer chaque titre individuellement depuis votre tableau de bord à tout moment.",
                "**Données de facturation** — conservées 10 ans conformément aux obligations comptables françaises.",
                "**Logs techniques** — conservés au maximum 12 mois à des fins de sécurité et de débogage.",
                "**Nouvelles d'Archipel Audio** — votre adresse est utilisée tant que votre compte existe et que vous ne vous y êtes pas opposé. La suppression du compte y met fin.",
              ]},
            ],
          },
          {
            title: "6. Vos droits",
            blocks: [
              { type: 'p', text: "Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez des droits suivants sur vos données personnelles :" },
              { type: 'ul', items: [
                "**Droit d'accès** — obtenir une copie des données que nous détenons sur vous.",
                "**Droit de rectification** — corriger toute donnée inexacte ou incomplète.",
                "**Droit à l'effacement** — demander la suppression de vos données.",
                "**Droit à la portabilité** — récupérer vos données dans un format structuré et lisible par machine.",
                "**Droit d'opposition** — vous opposer à un traitement spécifique, et à tout moment, sans avoir à vous justifier, à l'envoi des nouvelles d'Archipel Audio (Réglages ou lien de désinscription présent dans chaque email).",
                "**Droit de retirer votre consentement** à tout moment, sans que cela compromette la licéité des traitements antérieurs.",
              ]},
              { type: 'p', text: "Pour exercer ces droits, écrivez-nous à {email}. Vous disposez également du droit d'introduire une réclamation auprès de la CNIL (www.cnil.fr)." },
            ],
          },
          {
            title: "7. Cookies",
            blocks: [
              { type: 'p', text: "Versions n'utilise **pas de cookies de tracking ni de publicité**. Seuls des cookies strictement nécessaires au fonctionnement du service sont déposés sur votre appareil :" },
              { type: 'ul', items: [
                "Un cookie de session lié à votre authentification.",
                "Des éléments de stockage local (localStorage) pour mémoriser vos préférences (langue, DAW, paramètres d'interface).",
              ]},
              { type: 'p', text: "Ces traceurs étant strictement nécessaires à la fourniture du service, ils ne requièrent pas de consentement préalable conformément aux recommandations de la CNIL." },
            ],
          },
          {
            title: "8. Sécurité",
            blocks: [
              { type: 'p', text: "Toutes les communications entre votre navigateur et nos serveurs sont chiffrées via HTTPS. L'accès à vos fichiers audio est protégé par les politiques de sécurité (Row Level Security) de Supabase, qui garantissent que seul le propriétaire d'un fichier peut y accéder." },
            ],
          },
          {
            title: "9. Modifications",
            blocks: [
              { type: 'p', text: "Nous pouvons être amenés à modifier la présente politique pour l'adapter à des évolutions légales ou techniques. Toute modification substantielle vous sera notifiée par e-mail ou via une bannière dans l'application." },
            ],
          },
          {
            title: "10. Contact",
            blocks: [
              { type: 'p', text: "Pour toute question relative à vos données personnelles ou à la présente politique : {email}." },
            ],
          },
        ],
      },
      terms: {
        eyebrow: "CGU",
        title: "Conditions générales",
        titleEm: "d'utilisation",
        updated: "Dernière mise à jour : 20 octobre 2026",
        lede: "Les présentes conditions générales d'utilisation (« CGU ») régissent l'accès et l'utilisation du service Versions, accessible à l'adresse www.versions.studio. En créant un compte ou en utilisant le service, vous acceptez sans réserve les présentes CGU.",
        sections: [
          {
            title: "1. Objet du service",
            blocks: [
              { type: 'p', text: "Versions est un service en ligne d'analyse de mix audio par intelligence artificielle. Il permet à un utilisateur d'importer une piste audio (mix ou master), d'obtenir une analyse détaillée — équilibre fréquentiel, dynamique, stéréo, qualité d'écoute — sous forme d'une fiche, et de comparer les versions successives d'un même titre." },
              { type: 'p', text: "Le service est destiné à un usage professionnel ou personnel dans le cadre du processus créatif et technique de production musicale. Il ne constitue pas une prestation de mastering ni un avis d'ingénieur du son certifié." },
            ],
          },
          {
            title: "2. Éditeur",
            blocks: [
              { type: 'p', text: "Le service est édité par **Archipel Audio** ({archipel}), société par actions simplifiée (SAS) immatriculée en France sous le numéro SIRET 108 042 102 00013." },
              { type: 'p', text: "Contact : {publisherEmail}" },
            ],
          },
          {
            title: "3. Inscription et compte utilisateur",
            blocks: [
              { type: 'p', text: "L'accès au service nécessite la création d'un compte via l'authentification Google OAuth. Vous garantissez l'exactitude des informations transmises et vous engagez à maintenir la confidentialité de vos identifiants." },
              { type: 'p', text: "Le compte est strictement personnel. Vous êtes seul responsable de toute activité réalisée depuis votre compte. Vous devez nous informer immédiatement de toute utilisation non autorisée." },
              { type: 'p', text: "Vous pouvez supprimer votre compte à tout moment depuis vos réglages ou en nous contactant à {email}." },
            ],
          },
          {
            title: "4. Crédits, abonnement et facturation",
            blocks: [
              { type: 'p', text: "Le service fonctionne sur un système de crédits. Chaque analyse consomme un crédit. Les crédits peuvent être obtenus :" },
              { type: 'ul', items: [
                "**Via un abonnement mensuel** — un nombre de crédits est attribué chaque mois et expire à la fin de la période d'abonnement.",
                "**Via l'achat de packs ponctuels** — les crédits packs sont cumulables et n'expirent pas tant que votre compte reste actif.",
              ]},
              { type: 'p', text: "Les paiements sont traités par Stripe. Aucune donnée bancaire n'est stockée sur nos serveurs. Les prix indiqués sont en euros, toutes taxes comprises lorsque applicables." },
              { type: 'p', text: "Conformément à l'article L221-28 du Code de la consommation, vous renoncez à votre droit de rétractation pour les services numériques fournis immédiatement après votre commande. Cette renonciation est expressément acceptée au moment de la souscription." },
              { type: 'p', text: "Vous pouvez résilier votre abonnement à tout moment depuis vos réglages. La résiliation prend effet à la fin de la période en cours ; aucun remboursement prorata temporis n'est effectué." },
            ],
          },
          {
            title: "5. Propriété intellectuelle",
            blocks: [
              { type: 'p', text: "**Vos fichiers audio restent votre propriété exclusive.** Vous conservez l'ensemble des droits d'auteur, droits voisins et droits sur les masters relatifs aux pistes que vous importez. Versions ne revendique aucun droit sur vos œuvres." },
              { type: 'p', text: "En important une piste, vous nous accordez uniquement la licence limitée, non exclusive et révocable nécessaire au stockage, à la lecture et à l'analyse technique du fichier dans le cadre du service. Cette licence prend fin lorsque vous supprimez la piste ou votre compte." },
              { type: 'p', text: "Les fiches d'analyse générées par Versions, ainsi que les éléments de l'interface (textes, graphismes, logos, code), sont la propriété de l'éditeur et protégés par le droit de la propriété intellectuelle. Vous pouvez librement utiliser le contenu des fiches pour vos propres besoins de production, mais vous ne pouvez pas reproduire ou distribuer publiquement l'interface ou le service sans autorisation." },
              { type: 'p', text: "Vous garantissez détenir l'ensemble des droits nécessaires sur les fichiers que vous importez ou être expressément autorisé à les analyser sur le service. Cette garantie est confirmée par une acceptation explicite à chaque upload. Vous vous engagez à ne pas soumettre de contenu portant atteinte aux droits de tiers." },
            ],
          },
          {
            title: "6. Disponibilité et responsabilité",
            blocks: [
              { type: 'p', text: "Nous mettons tout en œuvre pour garantir la disponibilité du service, sans toutefois pouvoir l'assurer sans interruption. Des opérations de maintenance, des incidents techniques ou des facteurs externes peuvent entraîner des indisponibilités temporaires." },
              { type: 'p', text: "Les analyses produites par Versions sont fournies à titre indicatif. Elles ne sauraient se substituer à l'avis d'un ingénieur du son et n'engagent pas l'éditeur sur le résultat final d'une production. La décision artistique et technique finale vous appartient." },
              { type: 'p', text: "La responsabilité de l'éditeur ne saurait être engagée pour les dommages indirects (perte de données, perte de chance, manque à gagner) résultant de l'utilisation du service. La responsabilité globale de l'éditeur est en tout état de cause limitée au montant payé par l'utilisateur au cours des douze (12) derniers mois." },
            ],
          },
          {
            title: "7. Usage acceptable",
            blocks: [
              { type: 'p', text: "Vous vous engagez à ne pas :" },
              { type: 'ul', items: [
                "importer de contenu illicite, contrefaisant ou portant atteinte aux droits de tiers ;",
                "tenter d'accéder à des comptes ou ressources qui ne vous appartiennent pas ;",
                "perturber le fonctionnement du service ou d'en contourner les protections techniques ;",
                "extraire massivement ou automatiquement le contenu du service à des fins commerciales sans autorisation ;",
                "utiliser le service pour entraîner des modèles d'intelligence artificielle tiers.",
              ]},
              { type: 'p', text: "Tout manquement peut entraîner la suspension ou la résiliation de votre compte, sans préjudice des actions en réparation que l'éditeur pourrait engager." },
            ],
          },
          {
            title: "8. Données personnelles",
            blocks: [
              { type: 'p', text: "Le traitement de vos données personnelles est décrit en détail dans notre politique de confidentialité (lien en bas de page). Nous traitons vos données dans le respect du RGPD et de la loi Informatique et Libertés." },
            ],
          },
          {
            title: "9. Résiliation",
            blocks: [
              { type: 'p', text: "Vous pouvez cesser d'utiliser le service et supprimer votre compte à tout moment. L'éditeur peut suspendre ou résilier l'accès d'un utilisateur en cas de manquement aux présentes CGU, après notification lorsque cela est raisonnablement possible." },
              { type: 'p', text: "En cas de résiliation, les fichiers audio et données associées sont supprimés sous 30 jours, sous réserve des obligations légales de conservation (comptabilité, fiscalité)." },
            ],
          },
          {
            title: "10. Modifications des CGU",
            blocks: [
              { type: 'p', text: "Les présentes CGU peuvent être modifiées pour refléter l'évolution du service ou du cadre légal. Toute modification substantielle vous sera notifiée par e-mail ou via une bannière dans l'application. La poursuite de l'utilisation du service après notification vaut acceptation des nouvelles CGU." },
            ],
          },
          {
            title: "11. Droit applicable et juridiction",
            blocks: [
              { type: 'p', text: "Les présentes CGU sont soumises au droit français. À défaut de résolution amiable, tout litige relatif à leur exécution ou à leur interprétation sera soumis aux tribunaux français compétents, sauf disposition légale impérative contraire." },
              { type: 'p', text: "Conformément aux articles L611-1 et suivants du Code de la consommation, les utilisateurs consommateurs peuvent recourir à un médiateur de la consommation ou utiliser la plateforme européenne de règlement en ligne des litiges accessible à l'adresse https://ec.europa.eu/consumers/odr." },
            ],
          },
          {
            title: "12. Contact",
            blocks: [
              { type: 'p', text: "Pour toute question relative aux présentes CGU : {email}." },
            ],
          },
        ],
      },
    },
  },

  en: {
    /* ─────────────────────────── COMMON ────────────────────── */
    common: {
      loading: "LOADING...",
      save: "Save",
      saving: "Saving...",
      saved: "✓ Saved",
      cancel: "Cancel",
      delete: "Delete",
      rename: "Rename",
      create: "Create",
      close: "Close",
      confirm: "Confirm",
      ok: "OK",
      back: "Back",
      continue: "Continue",
      next: "Next",
      prev: "Previous",
      yes: "Yes",
      no: "No",
      search: "Search",
      reset: "Reset",
      tryAgain: "Try again",
      optional: "(optional)",
      required: "Required",
      copy: "Copy",
      copied: "Copied!",
      share: "Share",
      edit: "Edit",
      add: "Add",
      addPillPlaceholder: "Project, track, version",
      or: "or",
      of: "of",
      and: "and",
      by: "by",
      to: "to",
      from: "from",
      all: "All",
      none: "None",
      unknown: "Unknown",
      untitled: "Untitled",
      untitledMale: "Untitled",
      pending: "Pending",
      inProgress: "In progress",
      done: "Done",
      more: "More",
      less: "Less",
      showMore: "Show more",
      showLess: "Show less",
      viewDetails: "View details",
      hide: "Hide",
      show: "Show",
      new: "New",
      newFem: "New",
      processing: "Processing…",
      generating: "Generating…",
      analysing: "Analysing…",
      track: "track",
      tracks: "tracks",
      version: "version",
      versions: "versions",
      project: "project",
      projects: "projects",
    },

    /* ─────────────────────────── NAV ───────────────────────── */
    nav: {
      home: "Home",
      versions: "Versions",
      chat: "Chat",
      reglages: "Settings",
      profile: "Profile",
      back: "Back",
      newAnalysis: "New analysis",
    },

    /* ─────────────────────────── BRAND ─────────────────────── */
    brand: {
      tagline: "Audio production versioning",
      taglineAction: "Analyse · Compare · Evolve",
    },

    /* ─────────────────────────── AUTH ──────────────────────── */
    auth: {
      signInTitle: "SIGN IN",
      signUpTitle: "CREATE MY ACCOUNT",
      signInTab: "Sign in",
      signUpTab: "Sign up",
      signIn: "Sign in",
      signUp: "Sign up",
      signOut: "Sign out",
      google: "Continue with Google",
      apple: "Continue with Apple",
      facebook: "Continue with Facebook",
      or: "OR",
      orEmail: "or with email",
      email: "Email",
      password: "Password",
      forgotPassword: "Forgot password?",
      confirmEmail: "Check your email to confirm your account.",
      noAccount: "No account? Sign up",
      alreadyRegistered: "Already registered? Sign in",
      cgu1: "By continuing, you agree to our",
      cgu2: "Terms of Service",
      cgu3: "and",
      cgu4: "Privacy Policy",
      // Archipel Audio notice (migration 052). Versioned text: any change =
      // new version in src/lib/archipelConsent.js + new row in
      // public.archipel_text_versions.
      archipelNotice: "Versions is an Archipel Audio tool. Now and then, we'll email you our tools for musicians (AudioKit, AudioPass, Poll the Band). One-click unsubscribe in every email.",
      archipelPrivacy: "Privacy",
      archipelRefuse: "I don't want to receive them",
      // Password reset flow
      resetTitle: "Forgot password",
      resetSubtitle: "Enter your email and we'll send you a link to choose a new password.",
      resetSubmit: "Send link",
      resetSent: "Email sent. Click the link to choose a new password.",
      backToSignIn: "Back to sign in",
      // New password screen (after clicking the email link)
      updateTitle: "Choose a new password",
      updateSubtitle: "You can now set a new password for your account.",
      newPassword: "New password",
      confirmPassword: "Confirm password",
      updateSubmit: "Update",
      updateSuccess: "Password updated. You can sign in with it now.",
      updatePasswordMismatch: "The two passwords don't match.",
      updatePasswordTooShort: "Password must be at least 6 characters.",
      updateLinkExpired: "Link has expired. Request a new password reset email.",
      // Supabase Auth errors — translated so we don't leak raw backend strings
      errInvalidCredentials: "Incorrect email or password.",
      errSamePassword: "New password must be different from the old one.",
      errWeakPassword: "Password too short (6 characters minimum).",
      errUserAlreadyRegistered: "An account already exists with this email. Try signing in.",
      errEmailNotConfirmed: "Email not confirmed. Check your inbox (and spam folder).",
      errInvalidEmail: "Invalid email.",
      errRateLimit: "Too many attempts. Please try again in a few minutes.",
      errEmailRateLimit: "Too many emails sent. Wait a few minutes before trying again.",
      errOtpExpired: "This link has expired. Request a new one.",
      errOAuth: "Google sign-in failed. Try again or use email + password.",
      errSignupsDisabled: "Sign-ups are temporarily closed.",
      errNetwork: "Can't connect. Check your internet connection and try again.",
      errGeneric: "Something went wrong. Please try again in a moment.",
    },

    /* ─── Account deletion confirmation (route /confirm-delete-account) ─── */
    deleteAccount: {
      confirmFinalTitle: "Account deletion",
      confirmFinalMessage: "You're about to permanently delete your Versions account and all associated data. This action is irreversible.",
      confirmFinalBtn: "Delete permanently",
      confirmCancelBtn: "Cancel",
      confirmedTitle: "Account deleted ✓",
      confirmedMessage: "Your account has been deleted. You'll be redirected to the home page in a moment.",
      confirmTokenInvalid: "This link has expired or is no longer valid. Request a new deletion from your Settings.",
      confirmFailed: "An error occurred. Try again or email us at contact@versions.studio.",
      invalidLinkTitle: "Invalid link",
      invalidLinkMessage: "This link doesn't contain a confirmation token. Request a new deletion from your Settings.",
    },

    /* ─────────────────────────── HOME / WELCOME ────────────── */
    home: {
      greeting: "HI!",
      greetingWithName: "HI {name}!",
      newTrack: "New track",
      newVersion: "Add a version",
      pickTrack: "Which track?",
      myTracks: "My",
      myTracksAccent: "tracks",
      empty: "Import your first track to start the journey.",
      tipLabel: "Production tips",
      ctaAnalysis: "Analysis",
      playing: "Playing",
      play: "Play",
      pause: "Pause",
      add: "Add",
      userMenu: "User menu",
      logout: "Sign out",
      settings: "Settings",
      fallbackUser: "user",
      projectKicker: "Project",
      projectOptions: "Project options",
      share: "Share / Members",
      shareTrack: "Share this track",
      projectAvgScore: "Avg. score",
      searchPlaceholder: "Search a project, a track…",
      searchNoResults: "No results",
      searchProjectsLabel: "Projects",
      searchTracksLabel: "Tracks",
      searchHint: "↑↓ navigate · Enter open · Esc close",
      searchClear: "Clear search",
      myProjects: "My",
      myProjectsAccent: "projects",
      sharedWithMe: "Shared",
      sharedWithMeAccent: "with me",
      emptyProject: "No tracks yet.",
      newTrackInProject: "+ New track",
      rename: "Rename",
      replaceImage: "Replace image",
      changeImage: "Set image",
      removeImage: "Remove image",
      trackReplaceImage: "Replace artwork",
      trackChangeImage: "Add artwork",
      trackRemoveImage: "Remove artwork",
      delete: "Delete",
      cancel: "Cancel",
      ok: "OK",
      newProject: "New project",
      projectNamePlaceholder: "Project name",
      trackNamePlaceholder: "Track name",
      renameTrackTitle: "Rename track",
      renameProjectTitle: "Rename project",
      confirmRename: "Rename",
      confirmCreate: "Create",
      emptyProjectsMobile: "Create your first project to begin the journey.",
      heroResume: "Pick up where you left off",
      heroPlaying: "Playing",
      heroListen: "Listen",
      heroPause: "Pause",
      heroPlayTrack: "Play this track",
      heroPlayProject: "Play project",
      heroScoreLabel: "— Mix score",
      viewFiche: "View report",
      newVersionShort: "New version",
      impossible: "Not possible",
      lastProjectMsg: "At least one project is required. Create another project before deleting this one.",
      lastProjectMsgShort: "At least one project is required.",
      deleteProjectTitle: "Delete project?",
      deleteProjectMsgEmpty: "Delete project \"{name}\"?",
      deleteProjectMsgWithTracks: "Delete project \"{name}\" and its {n} {trackWord} (with all their versions and audio files)? This action is permanent.",
      deleteTrackTitle: "Delete track?",
      deleteTrackMsg: "Delete \"{name}\" and its {n} {versionWord}? This action is permanent.",
      statsTracks: "Tracks",
      statsVersions: "Versions",
      statsAvgScore: "Avg score",
      statsProgress: "Progress",
      projectSingular: "project",
      projectPlural: "projects",
      versionSingular: "version",
      versionPlural: "versions",
      trackSingular: "track",
      trackPlural: "tracks",
      analysisSingular: "analysis",
      analysisPlural: "analyses",
      statsOn: "on",
      statsNoAnalysis: "no analysis",
      statsEmptyCurve: "Analyze a few tracks to see your curve.",
      statsRecentAnalyses: "{n} latest analyses",
      statsCurveBuilding: "curve in progress",
      relativeToday: "today",
      relativeYesterday: "yesterday",
      relativeDaysAgo: "{n}d ago",
      relativeWeeksAgo: "{n}w ago",
      relativeMonthsAgo: "{n}mo ago",
      relativeDash: "—",
      lastAnalysis: "last analysis {when}",
      noAnalysisYet: "no analysis yet",
      cardLastAnalyzed: "Last analyzed track",
      cardLastAnalyzedEmpty: "No analysis yet.",
      rightSectionYou: "Recommendations",
      rightSectionKnow: "Did you know?",
      cardYourProgress: "Your progress",
      cardAvgScore: "Avg score {n}/100",
      cardLaunchFirst: "Launch your first analysis",
      cardNextStep: "Next step",
      cardWhyUseful: "What it's for?",
      cardWhyVersions: "Why \"Versions\"?",
      cardAdvice: "Advice",
      welcomeHi: "Welcome",
      welcomeHiName: "Welcome, {name}",
      onboardingTagline: "VERSIONS analyzes your mixes and compares your versions with each other. Let's start with your first track.",
      sloganStart: "Listen, ",
      sloganEm: "compare",
      sloganEnd: ", decide.",
      heroEyebrowWelcome: "Welcome {name} — let's start your first track",
      heroEyebrowActive: "Hi {name} — {n} tracks ready to listen to",
      heroEyebrowActiveSingle: "Hi {name} — 1 track ready to listen to",
      firstTrack: "+ My first track",
      firstProject: "+ My first project",
      gettingStarted: "Getting started",
      checkCreateProject: "Create your first project",
      checkFirstTrack: "Analyze a first track",
      checkCompare: "Compare two versions",
      checkExploreChat: "Explore chat questions",
      trackDragHandle: "Drag to move this track",
      trackMove: "Move track",
      trackOptions: "Options",
      trackAnalysis: "View analysis",
      tips: [
        "Taking regular breaks keeps your listening attentive and objective.",
        "Your ears fatigue after 45 min — a 10 min break saves you 2h of work.",
        "Listening to your mix in another context (car, headphones) reveals what the studio hides.",
        "Lowering the monitoring volume helps you spot balance imbalances.",
        "Stepping away from a mix for 24h completely changes your perception.",
        "Regularly comparing against a reference recalibrates your ear and your choices.",
        "Silence between sessions matters as much as the work itself.",
        "Listening at low volume is the best test: if the mix works quiet, it will work loud.",
      ],
    },

    /* ─────────────────────────── INPUT ─────────────────────── */
    input: {
      title: "NEW ANALYSIS",
      tagline: "Analyze · Compare · Evolve",
      taglineWord1: "Analyze",
      taglineWord2: "Compare",
      taglineWord3: "Evolve",
      tracksSingular: "track",
      tracksPlural: "tracks",
      confirmCreate: "Create",
      sectionMix: "YOUR MIX",
      sectionVocalType: "TRACK TYPE",
      sectionProject: "PROJECT",
      sectionTitle: "TITLE",
      sectionVersion: "VERSION",
      sectionDaw: "YOUR DAW",
      titlePlaceholder: "Track name",
      versionPlaceholder: "e.g. Mix v3, Demo, Master…",
      dawPlaceholder: "Select your DAW…",
      dropText: "Drag the file here or click",
      dropFormats: "WAV (recommended) · MP3 · FLAC — 70 MB max",
      vocalSung: "Vocal",
      vocalInstrumental: "Instrumental",
      vocalVoiceQuestion: "VOCALS ON THIS TRACK?",
      vocalComing: "Coming",
      vocalFinal: "Final instrumental",
      vocalComingTip: "You plan to add vocals on a future version",
      vocalFinalTip: "Purely instrumental piece, no vocals planned",
      vocalHintIdle: "This choice avoids flagging the lack of vocals as a flaw by mistake.",
      vocalHintComing: "The analysis will treat vocals as an upcoming step.",
      vocalHintFinal: "The vocal section will be ignored in the analysis and score.",
      projectPickerFirst: "+ Create your first project",
      projectPickerNew: "+ New project",
      projectLocked: "Project locked — this track is already attached to a project",
      projectLockedHint: "Project locked — this track already belongs to this project.",
      analyze: "Analyze",
      fieldsRemaining: "{filled}/{total} fields filled",
      newProjectTitle: "New project",
      newProjectPlaceholder: "Project name",
    },

    /* ─────────────────────────── LOADING ───────────────────── */
    loading: {
      title: "ANALYSIS IN PROGRESS",
      sub: "Your mix is being dissected.",
      cancel: "Cancel analysis",
      stepUpload: "Uploading file",
      stepListen: "Qualitative listening",
      stepExtract: "Extracting elements",
      stepDetectVocal: "Vocal detection",
      stepBuildFiche: "Building the report",
      stepSynthesis: "Final synthesis",
      stageListening: "Listening to your track…",
      stageAnalyzing: "Writing the diagnostic…",
      stageRag: "Cross-checking with the knowledge base…",
      stageFinal: "Final review…",
      errorTitle: "Analysis failed",
      errorRetry: "Try again",
      errorBack: "Go back",
      stepUploadOne: "Uploading file…",
      stepUploadMulti: "Uploading files…",
      stepListening: "Qualitative listening…",
      stepWriting: "Writing the report…",
      stepDone: "Analysis complete…",
      microUpload: "Upload",
      microListening: "Listening",
      microWriting: "Writing",
      microDone: "Finalization",
      titleBefore: "Analysis",
      titleEm: "in progress",
      didYouKnow: "Did you know?",
      cancel: "Cancel analysis",
      errorDuplicate: "File identical to version \"{name}\" already uploaded for this track.",
      errorDuplicateOtherTrack: "You've already analyzed this file in the track \"{track}\" (version \"{name}\") with the same parameters.",
      duplicateModalTitle: "Analysis already exists",
      duplicateModalSeeExisting: "View existing analysis",
      duplicateModalUploadAnyway: "Upload anyway",
      errorStart: "Start failed ({status})",
      errorFailed: "Analysis failed",
      errorTimeout: "Timeout — analysis took too long",
      errorUploadFailed: "File upload failed. Check your connection and try again.",
      // Backend error codes (versions-api lib/jobErrors.js) → translated strings
      errorAnalysisTimeout: "Analysis took too long. Please try again.",
      errorAnalysisService: "An external service is temporarily unavailable. Please try again in a few minutes.",
      errorAnalysisStorage: "Could not read your audio file. Please try again.",
      errorAnalysisParse: "Analysis failed while writing the report. Please try again.",
      errorJobNotFound: "This analysis no longer exists. Start a new one from your dashboard.",
      errorJobNotAwaiting: "This analysis is no longer awaiting input. Start a new one from your dashboard.",
      errorCancelled: "Upload cancelled",
      // 413 backend (audio > 12 min) — `{recv}` is filled in by the front
      // with the formatted received duration (e.g. " (14 min 32 s)"), empty otherwise.
      errorTooLongAudio: "Audio too long{recv}. Versions analyzes tracks up to 12 minutes.",
      // 413 backend (multer LIMIT_FILE_SIZE, cf. server.js error handler) —
      // file too heavy, regardless of duration. The exact threshold comes
      // from the backend via `maxBytes`; we just show the limit and let
      // the user figure out their own compression workflow.
      errorFileTooLarge: "File too large. Maximum allowed: 80 MB.",
      // 402 backend = empty credit balance.
      errorNoCredits: "No credits available. Redirecting to pricing…",
      dupCheckTitle: "Is this really a version of the same track?",
      dupCheckMessage: "This version lasts {thisDur} while the previous version lasts {prevDur} (difference {pct}%).",
      dupCheckContinue: "Continue analysis",
      dupCheckCancel: "Cancel",
      dupCheckNewTitle: "Create a new track",
      tips: [
        "Regular breaks help you stay attentive and objective while listening.",
        "Your ears get tired after 45 min — a 10-min break saves you 2 hours of work.",
        "The best mixes come from short sessions. Quality always beats quantity.",
        "Listening to your mix in another context (car, headphones) reveals what the studio hides.",
        "Lowering the monitoring volume helps you spot balance issues.",
        "Stepping away from a mix for 24h completely changes your perception.",
        "Your mix decisions are better in the morning — take advantage of fresh ears.",
        "A good mix comes from 10 key decisions, not 100 micro-adjustments.",
        "Regularly comparing with a reference recalibrates your ears and your choices.",
        "The silence between sessions is as important as the work itself.",
        "Listening at low volume is the best test: if the mix works quiet, it'll work loud.",
        "Ear fatigue is invisible — when you doubt a choice, it's often a sign to take a break.",
      ],
    },

    /* ─────────────────────────── FICHE ─────────────────────── */
    fiche: {
      headerBadgeRef: "REFERENCE MODE",
      headerBadgePerso: "PERSONAL MODE",
      headerVerdict: "VERDICT",
      headerScore: "SCORE",
      tabAnalysis: "ANALYSIS",
      tabAnalysisPerso: "DIAGNOSTIC",
      tabListen: "LISTENING",
      tabListenPerso: "FEELING",
      tabChain: "PROBABLE CHAIN",
      tabChainPerso: "ISSUES FOUND",
      tabPlugins: "PLUGINS IDENTIFIED",
      tabPluginsPerso: "RECOMMENDED TOOLS",
      tabReproduce: "REPRODUCE",
      tabActionPlan: "ACTION PLAN",
      tabListenSecond: "DEEP LISTENING",
      generating: "Generating…",
      kbActive: "Knowledge base active",
      clickToDig: "Click an element to dig deeper",
      noContent: "No content yet for this section.",
      sectionStrengths: "Strengths",
      sectionWeaknesses: "Weaknesses",
      sectionRisks: "Risks",
      sectionSuggestions: "Suggestions",
      sectionActions: "Priority actions",
      sectionNextSteps: "Next steps",
      sectionWhyThis: "Why this choice",
      sectionHowToApply: "How to apply it",
      addVersion: "Add a version",
      compareVersions: "Compare versions",
      viewComparison: "View comparison",
      exportPdf: "Export as PDF",
      sharePublic: "Public link",
      deleteVersion: "Delete this version",
      renameVersion: "Rename version",
      scoreOutOf: "/ 100",
      durationLabel: "Duration",
      analysedOn: "Analysed on",
      dawLabel: "DAW",
      versionLabel: "Version",
      projectLabel: "Project",
      difficulty: "Difficulty",
      impact: "Impact",
      priority: "Priority",
      priorityHigh: "High",
      priorityMedium: "Medium",
      priorityLow: "Low",
      confidenceMeasured: "MEASURED",
      confidenceIdentified: "IDENTIFIED",
      confidenceSuggested: "SUGGESTED",
      retakeAnalysis: "Re-run analysis",
      fetchingFiche: "Loading report…",
      ficheUnavailable: "Report unavailable",
      whatWasAnalysed: "What was analysed",
      vocalTypeVocal: "Vocal",
      vocalTypeInstrumental: "Instrumental",
      vocalTypeInstrumentalPending: "Instrumental (vocals coming)",
      vocalTypeInstrumentalFinal: "Final instrumental",
      voiceComingSoon: "VOCALS COMING",

      /* FicheScreen — detailed rendering */
      listeningTitle: "Qualitative listening",
      sectionSingular: "section",
      sectionPlural: "sections",
      analyzingTitle: "Analysis in progress",
      analyzingTitleEllipsis: "Analysis in progress…",
      analyzingSub1: "Qualitative listening and the report are generated in parallel.",
      analyzingSub2: "Allow 30 to 90 seconds depending on track length.",
      stepUpload: "Upload audio",
      stepListening: "Qualitative listening",
      stepFiche: "Report generation",
      didYouKnow: "Did you know?",
      analysisTips: [
        "A snare that lacks air: try a short reverb on a send, not an insert.",
        "Mix lacking punch: parallel compression on the drum bus, 4:1 ratio, plenty of blend.",
        "Vocal cutting too sharply: a de-esser after the compressor, not before.",
        "Kick and bass fighting: light sidechain on the bass, fast attack, release ~120ms.",
        "Mix sounding flat: check phase between overhead and close mics on drums.",
        "Muddy lows: subtractive EQ between 200 and 400 Hz on low instruments.",
        "Lacking depth: vary reverb times — short up front, long behind.",
        "Vocal that sings forward: automate volume note-by-note rather than heavy compression.",
        "Too much aggressive top end: a very gentle shelf from 10 kHz, -1 to -2 dB is often enough.",
        "Stereo collapsing in mono: check the mix bus in mono from the start, not at the end.",
      ],
      trackOptionsTitle: "Track options",
      menuRenameTrack: "Rename",
      menuExportTrack: "Export report",
      menuDeleteTrack: "Delete track",
      stageAllDone: "Current version",
      stageFicheDone: "Listening in progress",
      stageOther: "Analysis in progress",
      versionsLabel: "Versions",
      newVersionTitle: "New version",
      ariaPrev: "Previous",
      ariaNext: "Next",
      ariaClose: "Close",
      focusDawLabel: "DAW action",
      focusMeasured: "Measured",
      focusTarget: "Target",
      focusLinkedItems: "Linked elements",
      focusResolved: "Resolved",
      focusMarkResolved: "Mark as resolved",
      chatTitle: "Discussion",
      chatAiName: "Versions",
      chatEmpty: "Ask a question about this version — I'll look at the analysis and reply.",
      chatPlaceholder: "Type your question…",
      chatSend: "Send",
      chatError: "Connection error.",
      planTitle: "Action plan",
      planTagPriority: "Priority",
      planTagObservation: "Observation",
      planTagResolved: "Resolved",
      adjustmentSingular: "adjustment",
      adjustmentPlural: "adjustments",
      diagTitle: "Element-by-element diagnostic",
      categorySingular: "category",
      categoryPlural: "categories",
      elementSingular: "element",
      elementPlural: "elements",
      avgPrefix: " · avg. ",
      diagProgressDone: "completed",
      diagProgressTitle: "Tick each recommendation as you apply it in your DAW",
      diagItemMarkDoneLabel: "Mark as resolved",
      diagItemDoneLabel: "Resolved (click to uncheck)",
      diagItemTodoShort: "Mark as resolved",
      diagItemDoneShort: "Resolved",
      renameTrackPrompt: "New track name:",
      deleteTrackConfirm: 'Delete "{title}" and its {n} {versionWord}? This action is permanent.',
      versionSingular: "version",
      versionPlural: "versions",

      /* Score ring tooltip + bands */
      scoreAriaLabel: "See score details",
      scoreBandLow: "To rework",
      scoreBandMid: "In progress",
      scoreBandHigh: "Solid",
      scoreBandLowRange: "0–49 · To rework",
      scoreBandMidRange: "50–74 · In progress",
      scoreBandHighRange: "75–100 · Solid",
      scoreBandLowShort: "0–49",
      scoreBandMidShort: "50–74",
      scoreBandHighShort: "75–100",
      scoreGlobalTitle: "Global score",
      /* Artistic intent (fiche panel) */
      intentKicker: "Artistic intent",
      intentScopePrefix: "Applied to",
      intentScopeTrack: "this title",
      intentScopeVersion: "this version",
      intentEmpty: "Not set",
      intentEdit: "Edit",
      intentAdd: "Add an artistic intent",
      intentSave: "Save",
      intentSaving: "Saving…",
      intentCancel: "Cancel",
      intentPlaceholder: "Describe in a sentence or two the artistic intent of this track (mood, references, what you want it to convey)…",
      scoreFloorBadge: "Capped at {ceiling}/100",
      scoreFloorOneItem: "Score capped: 1 high-priority item to address before exceeding {ceiling}/100.",
      scoreFloorManyItems: "Score capped: {count} high-priority items to address before exceeding {ceiling}/100.",
      scoreFloorOriginal: "Raw score without cap: {original}/100.",
      scoreCalibStable: "Calibrated on previous version · stable",
      scoreCalibDelta: "Calibrated on previous version · {delta} pts",
      scoreDeltaUp: "↑ +{delta} points since {prev}",
      scoreDeltaDown: "↓ -{delta} points since {prev}",
      scoreDeltaStable: "= stable since {prev}",
      scoreNote: "The score reflects the mix's coherence (spatialisation, dynamics, balance, clarity). It's calibrated to stay comparable from one version to the next of the same track.",

      /* Mix indicators (6 tiles inside Score Global) */
      mixIndicators: {
        balance:    { label: "Balance",    low: "Off",         mid: "OK",       high: "Good",
          what: "Overall balance between every sound family (voice, instruments, low-end, drums, spatial, master).",
          how:  "Average across all diagnostic categories." },
        dynamique:  { label: "Dynamics",   low: "Flat",        mid: "Medium",   high: "Alive",
          what: "Breathing room of the mix, level variation between loud and soft sections, impact of limiting.",
          how:  "Derived from the Master & Loudness category items." },
        stereo:     { label: "Stereo",     low: "Narrow",      mid: "Medium",   high: "Wide",
          what: "Image width, depth, lateral placement and reverb coherence.",
          how:  "Derived from the Spatial & Reverb category items." },
        saturation: { label: "Saturation", low: "Excessive",   mid: "OK",       high: "Controlled",
          what: "Harmonic warmth and controlled distortion — neither dull nor aggressive.",
          how:  "Estimated from Master & Loudness (indirect indicator until the AI measures distortion directly)." },
        clarte:     { label: "Clarity",    low: "Muddy",       mid: "OK",       high: "Sharp",
          what: "Intelligibility and definition — each element stands out without being masked.",
          how:  "Average of the Voice and Instruments categories." },
        assise:     { label: "Low-end",    low: "Light",       mid: "OK",       high: "Solid",
          what: "Weight, tightness and cohesion of the low spectrum (sub, bass, kick).",
          how:  "Derived from the Bass & Kick category items." },
      },
      /* Mix indicator tooltip (generic copy) */
      // DSP visuels — EN translations (cf. FR section above pour le détail).
      dspViz: {
        lufsZoneSoft: "Too quiet",
        lufsZoneStreaming: "Streaming",
        lufsZoneTarget: "Competitive",
        lufsZoneCritical: "Overcompressed",

        lraKicker: "DYNAMIC RANGE",
        lraZoneCritical: "Crushed",
        lraZoneStandard: "Standard",
        lraZoneTarget: "Comfortable",
        lraZoneSoft: "Wide",

        truePeakKicker: "TRUE PEAK",
        truePeakZoneTarget: "Below target",
        truePeakZoneLow: "At risk",
        truePeakZoneCritical: "Clipping",

        voiceLabel: "VOICE",
        instruLabel: "INSTRU",
        voiceVerdictTarget: "Voice well placed ✓",
        voiceVerdictRetreat: "Needs work — voice too quiet",
        voiceVerdictProminent: "Voice forward — by design",

        widthKicker: "WIDTH",
        widthZoneNarrow: "Narrow",
        widthZoneStandard: "Standard",
        widthZoneWide: "Wide",
        widthZoneVeryWide: "Very wide",

        monoCompatKicker: "MONO COMPAT",
        monoCompatZoneOk: "Mono OK",
        monoCompatZoneLimit: "Mono borderline",
        monoCompatZoneDanger: "Mono needs work",

        corrKicker: "CORR L/R",
        corrZonePhaseInv: "Out of phase",
        corrZoneVeryWide: "Very wide",
        corrZoneTarget: "Balanced",
        corrZoneNarrow: "Narrow",

        balanceCenter: "centered",
        balanceLeftLeaning: "slightly left",
        balanceRightLeaning: "slightly right",
        balanceLeftHeavy: "leaning left",
        balanceRightHeavy: "leaning right",
      },

      miTooltipWhat: "What it measures",
      miTooltipHow: "How it's calculated",
      miTooltipSource: "Source",
      miTooltipSourceDirect: "Score provided directly by the AI analysis",
      miTooltipSourceDerived: "Derived from the diagnostic",
      miTooltipNoSource: "No matching category — falling back to the global score",
      miTooltipBasedOn: "Based on",

      /* Qualitative / Listening block titles + toggles */
      blockImpression: "Impression",
      blockPointsForts: "Strengths",
      blockATravailler: "To work on",
      blockEspace: "Space",
      blockDynamique: "Dynamics",
      blockPotentiel: "Potential",
      toggleReduce: "— Collapse",
      toggleExpandListening: "+ See full listening",
      toggleReduceDash: "− Collapse",

      /* AnalyzingState (finalisation) — titre split en 2 pour la charte v2
         (un mot en amber dans un <em>). */
      finalizingTitle: "Finalising analysis",
      finalizingSubtitle: "The report is being generated. Just a few more seconds.",
      finalizingTitleBefore: "Wrapping",
      finalizingTitleEm: "up",
      finalizingStatus: "Writing report",

      /* VocalTypePill */
      vocalPillVocalTitle: "Vocal track — the voice is evaluated",
      vocalPillInstrumentalPending: "Vocals coming",
      vocalPillInstrumentalPendingTitle: "Vocals coming on future versions",
      vocalPillInstrumentalFinalTitle: "Purely instrumental track — voice is not evaluated",

      /* Members / collaboration (verdict side panel) */
      membersPrivate: "Private · invite",
      membersShared: "{n} members",
      membersManage: "Manage access",
      /* Timeline actions */
      timelineBackHome: "Home",
      timelineShareBtn: "Share a link",
      timelineExportBtn: "Export as PDF",
      timelineScoreCardBtn: "Score Card",
      timelineShareTitle: "Generate a public read-only link",
      timelineExportTitle: "Generate a shareable PDF of this version",
      timelineScoreCardTitle: "Download a square Score Card for social media",
      timelineSavingInProgress: "Saving in progress…",

      /* VersionChat clear + placeholder */
      chatClearTitle: "Clear conversation",
      chatClearConfirmTitle: "Clear the conversation?",
      chatClearConfirmBody: "The conversation for this version will be permanently deleted.",
      chatClearConfirmLabel: "Clear",
      chatPlaceholderAnalysis: "…",
      chatFabTitle: "Discussion",
      chatPillPlaceholder: "Ask Versions…",
      chatRailLabel: "Ask",
      // Shown while the mastering seed is being generated by the backend
      // (~5-15s on first chat open). Replaced by the personalized charter
      // once /api/mastering-charter responds.
      chatSeedingMastering: "Preparing the mastering charter for your track…",

      /* EvolutionPanel */
      evolutionTitle: "Evolution",
      evolutionFromTo: "Evolution {first} → {last}",
      deltaEqualPrev: "= prev. v.",
      statVersionActive: "Active version",
      statDuration: "Duration",

      /* Notes */
      notesTitle: "My notes",
      notesTitleV2: "Version notes",
      notesStatusSaving: "Saving…",
      notesStatusSaved: "Saved",
      notesPlaceholder: "Your observations, reminders, TODOs for the next mix…",
      notesPlaceholderV2: "Your notes on this version…",
      notesPlaceholderDisabled: "Notes available once the analysis is saved.",
      notesClear: "Clear",
      notesSave: "Save",

      /* Plan filters + pending voice */
      pendingVoiceStep: "step to take",
      planShowAll: "Show all",
      planHideResolved: "Hide resolved",
      planShowAllTitle: "Show all adjustments",
      planHideResolvedTitle: "Hide resolved adjustments",
      planResolvedSingular: "resolved",
      planResolvedPlural: "resolved",
      planDetailsHint: "View details",
      pendingVerdict: "Analysis in progress…",
      translating: "Translating…",
      genreDeclared: "Genre",
      genreInferred: "Genre detected during analysis",
      genreInferredSuffix: "detected during analysis",
      genreEditPlaceholder: "e.g. indie pop, neo-soul, dub-techno…",
      genreEditTooltip: "Click to edit",
      genreAdd: "+ Add a genre",
      // CTA chat — rendered on 2 lines: discreet intro on top, main
      // label below. Opens the chat pre-seeded with the mastering
      // charter (LUFS / true peak / mono targets per destination).
      diagChatCtaIntro: "Mastering tips?",
      diagChatCta: "Let's talk in the chat",
      // Release readiness banner
      releaseEyebrow: "RELEASE READINESS",
      releaseAriaLabel: "Release status",
      releaseReady: "Ready to release",
      releaseAlmost: "Almost ready",
      releaseNotYet: "Not yet",
      releaseReadySub: "You can release it — no blocker detected.",
      releaseAlmostSubAction: "{count} priority action{plural} before releasing.",
      releaseAlmostSubScore: "Score to consolidate before release.",
      releaseNotYetSubAction: "{count} priority action{plural} pending.",
      releaseNotYetSubScore: "Score below threshold — more work before release.",
      // Mix mode variants ("Ready for mastering") — shown when the
      // version was uploaded as a MIX. The master & loudness section
      // stays informative and does not drag the score, so we frame the
      // cap as "ready to send to mastering" rather than "ready to ship".
      releaseMasteringEyebrow: "RELEASE READINESS",
      releaseMasteringReady: "Ready for mastering",
      releaseMasteringAlmost: "Almost ready to master",
      releaseMasteringNotYet: "Not yet ready",
      releaseMasteringReadySub: "You can send it to mastering — no blocker detected.",
      releaseMasteringAlmostSubAction: "{count} priority action{plural} before mastering.",
      releaseMasteringAlmostSubScore: "Score to consolidate before mastering.",
      releaseMasteringNotYetSubAction: "{count} priority action{plural} pending.",
      releaseMasteringNotYetSubScore: "Score below threshold — more work before mastering.",
      // Score Band social (B.3, 2026-05-20 redesign) — social positioning tier
      // shown next to the release readiness verdict. Option A "Sober and factual"
      // chosen with David. 6 tiers calibrated on globalScore /100:
      //   90-100 = reference, 80-89 = hit, 65-79 = pro,
      //   50-64 = advanced demo, 30-49 = developing, 0-29 = getting started.
      // No red in the palette by design: "Developing" and "Getting started" are
      // encouraging, not punitive.
      scoreBandAriaLabel: "Mix tier",
      scoreBandReference: "Reference level",
      scoreBandHit: "Hit level",
      scoreBandPro: "Pro level",
      scoreBandDemoAdvanced: "Advanced demo",
      scoreBandDeveloping: "In development",
      scoreBandStart: "Getting started",
      // Evolution banner
      evolutionSince: "Evolution since {prev}",
      evolutionSinceLast: "Evolution since last",
      evolutionAriaLabel: "Evolution since previous version",
      evolutionProgres: "Progress",
      evolutionRegressions: "Regressions",
      evolutionPersistants: "Persistent",
      evolutionNouveaux: "New",
    },

    /* ─────────────── COMPARE ─────────────── */
    compare: {
      title: "VERSION COMPARISON",
      subtitle: "What changed between your versions",
      pickA: "Version A",
      pickB: "Version B",
      differences: "Differences",
      improvements: "Improvements",
      regressions: "Regressions",
      suggestions: "Suggestions",
      sameScore: "Identical score",
      scoreDelta: "Score delta",
      noChange: "No notable change",
      generating: "Comparing…",
      empty: "At least two analysed versions are needed to compare.",
      otherTitleDetected: "Warning: these versions appear to be different tracks.",
      btn: "Compare",
      btnTitleEnabled: "Compare with another version",
      btnTitleDisabled: "No other version available",
      dropdownKicker: "COMPARE WITH",
      runningInline: "COMPARING — {a} VS {b}…",
      errorPrefix: "Error",
      headerKicker: "Comparison",
      colProgress: "Progress",
      colRegressions: "Regressions",
      colUnchanged: "Unchanged",
    },

    /* ─────────────── CHAT (fiche-contextual) ─────────────── */
    chat: {
      placeholder: "Ask a question about this version…",
      placeholderGeneric: "Your question…",
      send: "Send",
      loading: "The AI is thinking…",
      emptyTitle: "Ask the AI anything",
      emptySub: "It has access to the report, the audio analysis and the PureMix library.",
      suggestionLabel: "Suggestions",
      reset: "New conversation",
      errorGeneric: "Something went wrong. Try again.",
    },

    /* ─────────────── ASK MODAL ─────────────── */
    ask: {
      title: "ASK A QUESTION",
      sub: "Music production expert · All DAWs",
      placeholder: "Your question…",
      send: "Send",
      thinking: "Thinking…",
      exampleLabel: "Examples",
      examples: [
        "How do I mix a warm R&B vocal?",
        "Which compressor on bass for rap?",
        "How do I avoid muddy mixes?",
      ],
      heroTitle: "VERSIONS ASSISTANT",
      heroSub: "Music production expert · All DAWs · Knowledge base active",
      emptyHint: "Production tips, mixing, plugins,\ntechniques — ask anything you want.",
      noReply: "No reply.",
      thinkingShort: "Thinking",
      examplesShort: [
        "How do I properly compress vocals?",
        "EQ settings for an EDM kick",
        "Plate reverb vs hall reverb",
        "Best master bus chain",
      ],
    },

    /* ─────────────── FEEDBACK (tester questionnaire) ─────── */
    // 6-question modal, triggered from the sidebar ("Got feedback?")
    // or from the fiche. Deliberately short so testers can complete
    // it in under 3 minutes after 2-3 analyses.
    feedback: {
      triggerLabel: "Your feedback matters",
      triggerTitle: "Share your feedback on Versions — 3 min, 6 questions",
      title: "Your feedback",
      sub: "6 short questions — under 3 minutes",
      intro: "Your feedback helps us calibrate Versions. Skip any question you don't have an answer to.",
      // Q1: NPS
      q1Label: "On a 0 to 10 scale, would you recommend Versions to another artist mixing on their own?",
      q1Hint: "0 = never — 10 = absolutely",
      q1Low: "Not at all",
      q1High: "Absolutely",
      // Q2: positive surprise
      q2Label: "What surprised you most in the analysis?",
      q2Placeholder: "Something you didn't expect, a phrase that hit home…",
      // Q3: friction
      q3Label: "Was there a moment where you thought \"I don't get this\" or \"this isn't useful\"?",
      q3Placeholder: "A word that was too technical, a score that felt unfair, a blind spot…",
      // Q4: willingness to pay
      q4Label: "Would you have paid for this analysis? What price would have felt fair?",
      q4Placeholder: "Yes / no, and a rough number per analysis or per month if you have one in mind.",
      // Q5: verbatim landing
      q5Label: "If you had to describe Versions in one sentence to a musician friend, what would you say?",
      q5Placeholder: "One sentence, the way you'd say it out loud.",
      // Q6: priority
      q6Label: "One thing to change or add as a priority?",
      q6Placeholder: "Bug, missing feature, wording, pricing… whatever comes first.",
      // Footer
      cancel: "Later",
      submit: "Send my feedback",
      submitting: "Sending…",
      successTitle: "Got it — thank you.",
      successBody: "This is valuable. Your words will shape the next version.",
      successClose: "Close",
      errorTitle: "Couldn't send",
      errorBody: "Try again in a moment. If it persists, email us at contact@versions.studio.",
      errorRetry: "Try again",
      requiredHint: "At least one answer is needed to send.",
      mustBeSignedIn: "Sign in to send your feedback.",
    },

    /* ─────────────── VERSIONS SCREEN ─────────────── */
    versions: {
      title: "VERSIONS",
      subtitle: "Your tracks and their versions",
      empty: "No tracks yet.",
      emptyCta: "Import my first track",
      searchPlaceholder: "Search by title, project…",
      filterAll: "All",
      filterAnalyzed: "Analysed",
      filterPending: "Pending",
      noResults: "No results",
      noResultsSub: "Try different terms or reset filters",
      sortRecent: "Most recent",
      sortOldest: "Oldest",
      sortAlpha: "A → Z",
      sortScore: "By score",
      versionsCount: "{n} version",
      versionsCountPlural: "{n} versions",
      latestVersion: "Latest",
      play: "Play",
      openFiche: "View analysis",
      addVersion: "+ Version",
      menuRename: "Rename",
      menuDelete: "Delete",
      menuChangeProject: "Change project",
      menuChangeVocalType: "Track type",
      confirmDeleteTrackTitle: "Delete this track?",
      confirmDeleteTrackBody: "All versions and analyses will be removed. This action is irreversible.",
      confirmDeleteVersionTitle: "Delete this version?",
      confirmDeleteVersionBody: "The analysis and the linked audio file will be deleted. This action is irreversible.",

      /* Mobile / stylised page */
      mobileTitle: "MY TRACKS",
      trackSingular: "track",
      trackPlural: "tracks",
      versionSingular: "version",
      versionPlural: "versions",
      emptyMobile: "No tracks yet",
      emptyMobileSub: "Start your first analysis to get going",
      stopAction: "Stop",
      viewFicheCta: "View the analysis report",
      addVersionCta: "Add a version",
    },

    /* ─────────────── SIDEBAR ─────────────── */
    sidebar: {
      sectionTracks: "Tracks",
      sectionProjects: "Projects",
      sectionMyProjects: "My projects",
      dashboardLink: "Dashboard",
      signInLink: "Sign in / Sign up",
      newTrack: "+ New track",
      newProject: "+ New project",
      noTracks: "No tracks yet",
      emptyTracks: "No tracks yet",
      menuAddVersion: "Add a version",
      menuRename: "Rename",
      menuDelete: "Delete",
      menuMove: "Move",
      dragProject: "Drag to move this project",
      moveProject: "Move project",
      options: "Options",
      expand: "Expand",
      collapse: "Collapse",
      askAi: "Ask a question",
      homeLink: "Home",
      settingsLink: "Settings",
      signOut: "Sign out",
      premiumBadge: "Premium",
      // Credit balance shown under the user name. Test phase: every
      // account starts at 999, debit/refund pipeline is not wired
      // until Stripe is live.
      creditsLoading: "—",
      creditsSingular: "1 credit",
      creditsPlural: "{count} credits",
    },

    /* ─────────────── PLAYER ─────────────── */
    player: {
      idle: "Nothing playing",
      idleShort: "Nothing playing",
      idleHint: "Pick a track to listen",
      prev: "Previous",
      next: "Next",
      play: "Play",
      pause: "Pause",
      toggle: "Play / pause",
      loading: "Loading…",
      loadingInline: "loading…",
      noAudio: "Audio unavailable",
      speed: "Speed",
      volume: "Volume",
    },

    /* ─────────────── SETTINGS ─────────────── */
    // Dashboard "Archipel Audio news" card (accounts with no choice yet).
    // Versioned text toast-en-2026-10-A: any change = new version.
    archipelToast: {
      aria: "Archipel Audio news",
      text: "Versions is part of the Archipel Audio family. Would you like to receive our other tools for musicians now and then?",
      sub: "By email · one-click unsubscribe",
      privacy: "Privacy",
      no: "No thanks",
      yes: "Yes, please",
      later: "Later",
    },
    reglages: {
      title: "SETTINGS",
      subtitle: "Manage your profile and preferences",
      sectionAvatar: "PROFILE PICTURE",
      sectionProfile: "PROFILE",
      sectionDaw: "DEFAULT DAW",
      sectionLang: "LANGUAGE",
      sectionBank: "BANK DETAILS",
      sectionSecurity: "SECURITY",
      sectionData: "DATA",
      sectionSubscription: "SUBSCRIPTION",
      sectionPayment: "PAYMENT",
      sectionPreferences: "PREFERENCES",
      avatarHint: "Click the avatar to change your picture",
      firstName: "FIRST NAME",
      firstNamePlaceholder: "Your first name",
      lastName: "LAST NAME",
      lastNamePlaceholder: "Your last name",
      emailLabel: "EMAIL",
      dawNone: "None (ask every time)",
      langFrench: "Français",
      langEnglish: "English",
      bankHint: "These details are encrypted and only used for subscription payouts.",
      bankPremium: "PREMIUM",
      ibanLabel: "IBAN",
      bicLabel: "BIC / SWIFT",
      save: "Save",
      saving: "Saving...",
      saved: "✓ Saved",
      signOut: "Sign out",
      planFree: "5 analyses / month",
      planCurrent: "CURRENT PLAN",
      upgrade: "GO PRO",
      proFeatures: "Unlimited analyses · PDF export · Enhanced assistant · Full history",
      notifNews: "Notifications — News & updates",
      dangerZone: "Danger zone",
      deleteAccount: "Delete my account",
      exportPdf: "Export my analyses",
      exportPdfDesc: "Download all your reports as PDF",
      exportData: "Export my data",
      exportDataDesc: "Full archive in JSON format",
      deleteData: "Delete all my data",
      irreversible: "This action is irreversible. All your analyses and preferences will be deleted.",
      changePhoto: "Change photo",
      username: "Username",
      noCard: "No card on file",
      cardRequired: "Required for Pro plan",
      addCard: "Add a card",
      /* Mini-modal settings v2 */
      miniHead: "Modal · Settings",
      miniTitleBefore: "My",
      miniTitleEm: "settings",
      miniEyebrow: "My account",
      miniAccountPlanFree: "Free",
      creditSingular: "credit",
      creditsPlural: "credits",
      renewsOn: "Renews {date}",
      buyCreditsCta: "Buy credits",
      manageSubscriptionCta: "Manage subscription",
      miniAvatarLabel: "Profile photo",
      miniAvatarHint: "Click to change",
      miniProfileLabel: "Full name",
      miniProfileHint: "",
      miniLangLabel: "Language",
      miniLangHint: "",
      miniDawLabel: "Default DAW",
      miniDawHint: "For targeted action plans",
      miniBankLabel: "Bank details",
      miniBankHint: "",
      miniAccountLabel: "Account",
      miniAccountPlanFree: "Free",
      miniAccountPlanPremium: "Premium",
      replayOnboardingLabel: "Onboarding guide",
      replayOnboardingHint: "Restart the step-by-step guide",
      replayOnboardingBtn: "Replay",
      // Archipel Audio news (migration 052) — versioned text
      // (acct-en-2026-10-A), see src/lib/archipelConsent.js.
      archipelLabel: "Archipel Audio news",
      archipelHint: "Now and then, get our tools for musicians (AudioKit, AudioPass, Poll the Band). One-click unsubscribe in every email.",
      archipelYes: "Yes",
      archipelNo: "No",
      archipelError: "Couldn't save this choice. Please try again.",
      // Subscription cancellation (visible only when subscribed).
      // Direct Stripe cancellation (shipped 2026-05-31). Falls back to
      // mailto if API fails or stripe_subscription_id is missing.
      cancelSubLabel: "Subscription",
      cancelSubHint: "Cancel your current subscription",
      cancelSubBtn: "Cancel",
      cancelSubModalTitle: "Cancel subscription",
      cancelSubModalMessage: "You keep access and your credits until the end of the period you've already paid for. No further charges will be made after that date. You can resubscribe anytime.",
      cancelSubModalConfirm: "Confirm cancellation",
      cancelSubSuccessTitle: "Cancellation registered",
      cancelSubSuccessMessage: "Done. You keep access and your credits until {date}. See you soon!",
      cancelSubSuccessMessageNoDate: "Done. You keep access until the end of your current period. See you soon!",
      // Account deletion — danger button + confirmation modal.
      deleteAccountLabel: "Delete my account",
      deleteAccountHint: "Permanently delete your account and all your data",
      deleteAccountBtn: "Delete",
      deleteAccountModalTitle: "Delete my account",
      deleteAccountModalMessage: "This action is irreversible. To confirm, we'll send you an email with a confirmation link. The deletion will only happen after you click that link.",
      deleteAccountModalConfirm: "Send confirmation email",
      deleteAccountErrorTitle: "Deletion failed",
      deleteAccountErrorMessage: "An error occurred while sending the confirmation email. Try again in a moment or email us at contact@versions.studio if the problem persists.",
      deleteAccountEmailSentTitle: "Email sent",
      deleteAccountEmailSentMessage: "We sent you an email to confirm the deletion. Click the link to finalize. The link is valid for 1 hour.",
      mailtoCancelSubSubject: "Cancel my subscription",
      mailtoCancelSubBody: "Hello,\n\nI'd like to cancel my Versions subscription.\n\nAccount email: {email}\n\nThanks.",
      close: "Close",
    },

    /* ─────────────── AVATAR MENU ─────────────── */
    avatarMenu: {
      premium: "Upgrade to Premium",
      settings: "Settings",
      help: "Help & support",
      logout: "Sign out",
      fallbackUser: "User",
      fallbackEmail: "user@example.com",
      planFree: "FREE",
    },

    /* ─────────────── ONBOARDING FIRST PROJECT ─────────────── */
    onboardingFirst: {
      kicker: "First step",
      welcome: "Welcome to VERSIONS.",
      welcomeNamed: "Welcome, {name}.",
      body: "To begin, create your first project. It's a folder that will group your tracks (an album, an EP, a work session…). You can create more later.",
      projectNameLabel: "Project name",
      projectDefault: "My first project",
      projectPlaceholder: "My first project",
      creating: "Creating…",
      cta: "Create my project",
      errorGeneric: "Unable to create project.",
    },

    /* ─────────────── ADD MODAL ─────────────── */
    addModal: {
      title: "Add",
      rootTitleBefore: "Add",
      rootTitleEm: "what?",
      back: "← Back",
      close: "Close",
      cancel: "Cancel",
      choiceNewProjectLabel: "New project",
      choiceNewProjectDesc: "Album, EP, session…",
      choiceNewTrackLabel: "New track",
      choiceNewTrackDesc: "In an existing project",
      choiceNewTrackDescDisabled: "Create a project first",
      choiceAddVersionLabel: "New version",
      choiceAddVersionDesc: "Of an existing track",
      choiceAddVersionDescDisabled: "Create a track first",
      pickProjectTitle: "In which project?",
      pickTrackTitle: "Which track?",
      createNewProject: "Create a new project",
      newProjectStepTitle: "Project name",
      newProjectPlaceholder: "My EP, album, etc.",
      newProjectConfirm: "Create",
      trackSingular: "track",
      trackPlural: "tracks",
      versionSingular: "version",
      versionPlural: "versions",
      // Upload step
      uploadInProject: "Project",
      uploadAddVersionTo: "New version of",
      uploadMixLabel: "Your mix",
      uploadDropText: "Drop the file here or click to pick",
      uploadDropFormats: "WAV (recommended) · MP3 · FLAC · 70 MB max",
      uploadTitleLabel: "Title",
      uploadTitlePlaceholder: "Track name",
      uploadVersionLabel: "Name your version",
      uploadVersionPlaceholder: "v1, rough, master…",
      uploadVocalLabel: "Track type",
      uploadVocalSung: "Vocal",
      uploadVocalInstrumental: "Instrumental",
      uploadVocalComing: "Vocals to come",
      uploadVocalFinal: "Final",
      // "Has this mix been mastered?" question on upload (2026-05-20 redesign, roadmap C.2).
      // 3 options Yes / No / Auto-detect. Drives the weighting of the master &
      // loudness section in the overall score (Yes: strict, No / Auto: lenient)
      // + release verdict.
      uploadTypeLabel: "Has this mix been mastered?",
      uploadTypeYes: "Yes",
      uploadTypeNo: "No",
      uploadTypeMasterConfirmTitle: "Really mastered?",
      uploadTypeMasterConfirmMessage: "Are you sure this file is mastered? Not a mix with a limiter or mastering plugin on the master bus for monitoring, but the file you send as-is to Spotify, Apple Music or your distributor — with no further changes planned.",
      uploadTypeMasterConfirmYes: "Yes, mastered",
      uploadTypeMasterConfirmNo: "No, still mixing",
      uploadTypeYesHint: "Finalized and mastered file, no further changes planned — will be evaluated as a release-ready track.",
      uploadTypeNoHint: "Mix in progress — it's the default. Your track is evaluated without requiring finished-master levels. Even with a limiter or a mastering plugin on the master bus for monitoring, keep No while you're still tweaking.",
      uploadDawLabel: "Your DAW",
      uploadDawPlaceholder: "Pick your DAW…",
      uploadGenreLabel: "Musical genre",
      uploadGenrePlaceholder: "e.g. indie pop, neo-soul, dub-techno…",
      uploadGenreAutoHint: "We'll detect the genre during analysis",
      uploadGenreAutoBtn: "Detect automatically",
      uploadCta: "Run analysis",
      uploadCtaIncomplete: "Fill in fields to run",
      copyrightAck: "I hold the rights to this audio file or I am authorized to analyze it on Versions.",
      uploadBpmLabel: "BPM",
      uploadBpmHint: "Optional — leave empty for auto detection.",
      uploadBpmPlaceholder: "e.g. 120",
      // Audio duration cap (12 min). Blocks in-browser before POST,
      // double-validated server-side.
      uploadDurationReading: "Reading file…",
      uploadDurationTooLongTitle: "File too long",
      uploadDurationTooLongDetail: "Versions analyzes tracks up to 12 minutes. This file is {dur}.",
      uploadDurationUnreadable: "File format not readable. Try a different file.",
    },

    /* ─────────────── MODALS ─────────────── */
    modals: {
      renameTitle: "Rename",
      renamePlaceholder: "New name",
      renameConfirm: "Rename",
      confirmTitle: "Confirm action",
      confirmDeleteDefault: "This action is irreversible. Continue?",
      noCreditsTitle: "Out of credits",
      noCreditsBody: "You're out of analysis credits. Subscribe or buy a pack to keep analyzing your mixes.",
      noCreditsCta: "See plans",
      noCreditsCancel: "Later",
      addTitle: "Add a version",
      addVersionName: "Version name",
      addVersionPlaceholder: "e.g. Mix v3, Master, Radio Edit…",
      addSubmit: "Add",
      shareTitle: "Share this report",
      shareSub: "Anyone with this link can view the report.",
      shareCreate: "Create a public link",
      shareRevoke: "Disable the link",
      shareCopy: "Copy link",
      shareCopied: "Link copied!",
      shareModalTitle: "Share a public link",
      shareTitleBefore: "Public",
      shareTitleEm: "link",
      shareSubPrefix: "For",
      shareVersionPrefix: "Version",
      shareLoading: "Loading…",
      shareActiveBody: "Link active. Anyone with this URL can view the report read-only (no login required). You can disable it any time.",
      shareStatusActive: "Active",
      shareCopyShort: "Copy",
      shareCopiedShort: "Copied",
      shareDisable: "Disable",
      shareClose: "Close",
      shareInactiveBody: "Generates a unique URL for this version. Anyone with the link can view the report read-only (no login required). No other version, project, or external notes are exposed. The link can be disabled at any time.",
      shareCancel: "Cancel",
      shareEnable: "Enable link",
      shareEnabling: "Enabling…",
      exportPdfTitle: "Export as PDF",
      exportPdfSub: "Choose the level of detail.",
      exportPdfFull: "Full report",
      exportPdfSummary: "Summary (1 page)",
      exportPdfDownload: "Download",
      exportPdfGenerating: "Generating PDF…",
      exportPdfModalTitle: "Export report as PDF",
      exportPdfEyebrow: "PDF Export",
      exportPdfTitleBefore: "Export as",
      exportPdfTitleEm: "PDF",
      exportPdfSubPrefix: "For",
      exportPdfVersionPrefix: "Version",
      exportPdfSections: "Sections to include",
      exportPdfOptListeningLabel: "Listening section",
      exportPdfOptListeningHint: "Impression, strengths, things to work on…",
      exportPdfOptDiagnosticLabel: "Diagnostic",
      exportPdfOptDiagnosticHint: "Scores and details by category",
      exportPdfOptPlanLabel: "Action plan",
      exportPdfOptPlanHint: "Prioritized adjustments",
      exportPdfOptNotesLabel: "Notes",
      exportPdfOptNotesHint: "Your personal notes on the report",
      exportPdfNotAvailable: "— not available",
      exportPdfCancel: "Cancel",
      exportPdfExport: "Export",
      exportPdfGeneratingShort: "Generating…",
      onboardingWelcome: "Welcome to VERSIONS",
      onboardingSub: "Analyse, compare and evolve your productions.",
      onboardingStart: "Get started",
      onboardingSkip: "Skip",
      onboardingStep1Title: "Upload your mix",
      onboardingStep1Body: "Send your audio file — the AI does the rest.",
      onboardingStep2Title: "Read your report",
      onboardingStep2Body: "Detailed diagnostic, strengths, weaknesses, action plan.",
      onboardingStep3Title: "Compare your versions",
      onboardingStep3Body: "Track the evolution of each song version after version.",
      vocalBannerTitle: "Is this track vocal or instrumental?",
      vocalBannerBody: "To refine the analysis and avoid flagging missing vocals as a flaw by mistake.",
      vocalBannerConfirm: "Confirm",
      vocalBannerLater: "Later",
      vocalSuggestAria: "Vocal type suggestion",
      vocalSuggestTitle: "We heard vocals on this version",
      vocalSuggestBody: "This track is still marked \"Vocals coming\". Switch it to \"Vocal\"?",
      vocalSuggestAccept: "Yes, switch to Vocal",
      vocalSuggestDismiss: "No thanks",
    },

    /* ─────────────── VCHIP (version badge) ─────────── */
    vchip: {
      optionsTitle: "Version options",
      confirmDeleteTitle: "Delete this version?",
      confirmDeleteBody: 'Delete the version "{name}"? This action is permanent.',
      confirmDeleteConfirm: "Delete",
      menuRename: "Rename",
      menuDelete: "Delete",
      renameVersionTitle: "Rename version",
      renameVersionPlaceholder: "Version name",
      renameSubmit: "Rename",
    },

    /* ─────────────── PUBLIC FICHE ───────────── */
    publicFiche: {
      headerShared: "Shared report",
      headerPoweredBy: "Powered by",
      cta: "Try VERSIONS",
      ctaSub: "Create your account and analyse your own tracks.",
      expired: "This link is no longer active.",
      notFound: "Report not found.",
      loading: "Loading the report…",
      notFoundTitle: "Link not found",
      notFoundBody: "This share link is no longer active, or has been disabled by its owner.",
      notFoundHome: "Back to home",
      topbarCta: "Discover Versions",
      verdictFallback: "Report",
      versionPrefix: "Version {name}",
      footerText: "Report generated with Versions · read-only",
      artistNotesTitle: "Artist's notes",
    },

    /* ─────────────── COMMENTS (collaboration) ──────────────── */
    comments: {
      title: "Comments",
      subtitle: "Discuss this version with your collaborators.",
      empty: "No comments yet.",
      placeholder: "Write a comment…",
      send: "Comment",
      sending: "Sending…",
      signInToComment: "Sign in to leave a comment.",
      signInCta: "Sign in",
      resolve: "Mark resolved",
      unresolve: "Reopen",
      resolved: "Resolved",
      deleteLabel: "Delete",
      deleteConfirm: "Delete this comment?",
      you: "You",
      countOne: "{n} comment",
      countMany: "{n} comments",
      hideResolved: "Hide resolved",
      showResolved: "Show resolved",
      anchorLabel: "Related section",
      anchorAll: "General",
      filterAll: "All",
      liveHere: "here now",
    },

    /* ─────────────── SHARE / MEMBERS (collaboration) ──────────────── */
    share: {
      title: "Project members",
      subtitle: "Invite collaborators and manage their access.",
      scopeLabel: "Share:",
      scopeProject: "Whole project",
      scopeTrackPrefix: "Track:",
      inviteEmailLabel: "Invite by email",
      emailPlaceholder: "email@example.com",
      messagePlaceholder: "Message (optional) — a note for the invitee…",
      inviteBtn: "Invite",
      inviteSent: "Invitation sent.",
      inviteError: "Sending failed.",
      linkTitle: "Invite link",
      generateLink: "Generate a link",
      linkCopied: "Link copied to clipboard.",
      linkHint: "Anyone with this link who signs in joins the project.",
      membersTitle: "Members",
      pendingTitle: "Pending invitations",
      remove: "Remove",
      close: "Close",
      roles: {
        owner: "Owner",
        editor: "Editor",
        commenter: "Commenter",
        viewer: "Viewer",
      },
    },

    /* ─────────────── INVITATION / JOIN ──────────────── */
    join: {
      loading: "Loading invitation…",
      title: "Invitation to collaborate",
      intro: "You're invited to join {project}, as:",
      joinBtn: "Join the project",
      joining: "Signing you in…",
      signInPrompt: "Sign in or create an account to join.",
      home: "Back to home",
      invalidTitle: "Invalid invitation",
      invalidGeneric: "This invitation is no longer valid.",
      invalid: {
        not_found: "This invite link could not be found.",
        expired: "This invitation has expired.",
        used: "This invitation has already been used.",
      },
      errorGeneric: "Could not join this project.",
      errors: {
        auth_required: "Sign in to join.",
        expired: "This invitation has expired.",
        used: "This invitation has already been used.",
        not_found: "Invitation not found.",
        failed: "Something went wrong, try again.",
      },
    },

    /* ─────────────── ERRORS ─────────────── */
    errors: {
      generic: "Something went wrong.",
      network: "Connection interrupted. Check your internet.",
      uploadFailed: "File upload failed.",
      analysisFailed: "Analysis failed. Try again in a moment.",
      fileTooBig: "File too large (70 MB max).",
      fileType: "Unsupported format. Use WAV, MP3 or FLAC.",
      requiredField: "This field is required.",
      invalidEmail: "Invalid email.",
      weakPassword: "Password too short (6 characters min.).",
      loadProfile: "Unable to load your profile.",
      saveProfile: "Unable to save your changes.",
      projectCreate: "Creation failed, please try again.",
      compareNeedsFiches: "Both versions must have an analysis report",
      saveFailedTitle: "Couldn't save",
      saveFailedMessageRefunded: "Your analysis ran fine but we couldn't save it. Your credit has been refunded automatically — feel free to try again.",
      saveFailedMessageManual: "Your analysis ran fine but we couldn't save it. If your credit was debited, email us at contact@versions.studio and we'll restore it.",
      saveFailedOk: "OK",
    },

    /* ─────────────── DATE / TIME ───────────── */
    datetime: {
      today: "Today",
      yesterday: "Yesterday",
      daysAgo: "{n} days ago",
      weeksAgo: "{n} weeks ago",
      monthsAgo: "{n} months ago",
      justNow: "Just now",
      minutesAgo: "{n} min ago",
      hoursAgo: "{n} h ago",
      months: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      ],
      monthsLong: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December",
      ],
    },

    /* ─────────────── PRICING ─────────────── */
    pricing: {
      // Topbar
      topbarHome: "Home",
      topbarCurrent: "Pricing",
      topbarBackAria: "Back to home",

      // Hero
      heroEyebrow: "Pricing",
      heroTitleStart: "Pay for what ",
      heroTitleEm: "you mix",
      heroTitleEnd: ".",
      heroSub: "A single analysis, a pack to dig into a project, or a subscription once you mix on a roll. No hidden commitment.",
      // Decorative hero chips — generic terms (no plan or pack names)
      heroChip1: "PAY AS YOU GO",
      heroChip2: "SUBSCRIPTION",
      heroChip3: "LIFETIME CREDITS",
      heroChip4: "AT YOUR PACE",
      heroChip5: "CUSTOM",

      // Checkout errors
      errCheckoutNotConfigured: "This offer isn't configured yet. Try again in a moment.",
      errCheckoutPrefix: "Payment error: ",
      errUnknown: "unknown",

      // À la carte (packs)
      packsEyebrow: "Pay as you go",
      packsTitleStart: "One analysis, one pack, ",
      packsTitleEm: "no commitment",
      packsTitleEnd: ".",
      packsLede: "Buy when you need them, your credits never expire.",
      packAnalysisSingular: "Analysis",
      packAnalysisPlural: "Analyses",
      packPerUnit: "€/analysis",
      packBuy: "Buy",
      packRedirecting: "Redirecting…",

      // Ribbons (resolved from plan.highlightKey)
      ribbons: {
        mostChosen: "Most chosen",
        cheapestPerUnit: "Cheapest /unit",
        recommended: "Recommended",
      },

      // "All-included" strip
      includedLabel: "Included in every analysis",
      included1: "Full report",
      included2: "Contextual chat",
      included3: "Version comparison",
      included4: "PDF export + Score Card PNG",
      included5: "Progress tracking",

      // Subscriptions
      subsEyebrow: "Subscriptions",
      subsTitleStart: "When analysis becomes a reflex, ",
      subsTitleEm: "subscribe",
      subsTitleEnd: ".",
      subsLede: "Monthly allowance, best per-unit price, cancel anytime.",
      subsPluginPerk: "And in the plugin: unlimited express listening + AI chat.",
      subAllowanceLine1: "analyses",
      subAllowanceLine2: "per month",
      subPerMonth: "/month",
      subUnitLine: "i.e. {price} €/analysis",
      subChoose: "Choose",
      // Subscription descriptions indexed by plan.key
      subDescriptions: {
        sub_indie: "12 analyses per month, roll over as long as your subscription is active.",
        sub_pro: "30 analyses per month, roll over as long as your subscription is active. For artists in production cycle.",
      },

      // Schools / training centers
      schoolEyebrow: "Schools & training centers",
      schoolTitleStart: "For ",
      schoolTitleEm: "organizations",
      schoolTitleEnd: ", we tailor a quote.",
      schoolLede: "Team accounts, pedagogical support, pricing tailored to volume.",
      schoolCardLabel: "School",
      schoolCardPrice: "Custom quote",
      schoolCardHint: "Volume-based pricing",
      schoolMailSubject: "Versions — school / training center partnership",
      schoolCta: "Contact us",

      // FAQ
      faqEyebrow: "Frequently asked questions",
      faqTitleStart: "Before you commit, ",
      faqTitleEm: "you can know it all",
      faqTitleEnd: ".",
      faq1Q: "Do my credits expire?",
      faq1A: "Pack credits never expire. Subscription credits roll over as long as your subscription is active (no monthly reset), but disappear if you cancel — pack credits stay. Your generated reports stay forever in your dashboard.",
      faq2Q: "Can I combine a pack and a subscription?",
      faq2A: "Yes. Pack credits stay available on top of your monthly allowance. We consume the subscription allowance first, then pack credits — nothing is lost.",
      faq3Q: "Can I cancel my subscription anytime?",
      faq3A: "Yes, free of charge. Cancellation takes effect at the end of the current month. Your generated reports stay accessible for life in your dashboard, even after cancellation.",
      faq4Q: "What happens if an analysis fails?",
      faq4A: "No credit is charged when an analysis doesn't go through. If we already started debiting and a step fails, the credit is automatically restored and you can retry.",
      faq5Q: "Is there a duration limit per audio file?",
      faq5A: "Yes, 12 minutes max per file. That's plenty for a track, and it lets us guarantee low prices by keeping analysis costs in check.",
      faq6Q: "Are prices net or VAT-inclusive?",
      faq6A: "All prices shown include VAT (French VAT). A compliant invoice is auto-generated after each purchase.",

      // Footer
      footerLine: "A question before getting started?",
    },

    /* ─────────────── LANDING ─────────────── */
    landing: {
      ctaPrimary: "Analyze my first track",
      ctaSample: "See an example",
      // Free-first badge shown above hero CTA for disconnected visitors only.
      freeFirstBadge: "First analysis on us",
      freeFirstBadgeShort: "1 free analysis",
      ctaFooter: "Analyze my first track",

      mockScoreEyebrow: "OVERALL SCORE",
      mockScoreTag: "Solid mix",
      mockScoreBar1: "Balance",
      mockScoreBar2: "Dynamics",
      mockScoreBar3: "Stereo",
      mockScoreBar4: "Saturation",

      mockDiagEyebrow: "DIAGNOSIS",
      mockDiagTag: "VOCALS",
      mockDiagTitle: "The lead vocal lacks presence in the mids.",
      mockDiagHowLabel: "ACTION",
      mockDiagHowText: "Boost +2 dB around 3 kHz, Q ≈ 1.2 — to bring the voice forward without making it harsh.",
      mockDiagPlugin: "Parametric EQ",
      mockDiagCheck: "Done",

      mockEvoEyebrow: "PROGRESS",
      mockEvoUnit: "pts",
      mockEvoText: "Vocals better placed, bass more controlled, stereo image balanced.",

      // Chat conversation mockup — alt version of the 3 cards
      chatHead: "VOCALS — CHORUS",
      chatVersionPill: "V2",
      chatUserQ1: "Why doesn't the chorus take off?",
      chatScoreImpact: "Vocals: 74 → 82 estimated",
      chatUserQ2: "How does V2 compare to V1?",
      chatEvoDelta: "+7 pts",
      chatEvoSummary: "Vocals better placed, bass more controlled.",

      // Constellation chips mockup — small decorative elements
      chip1: "SCORE 82/100",
      chip2: "SOLID MIX",
      chip3: "VOCALS · +2 dB @ 3 kHz",
      chip4: "PARAMETRIC EQ",
      chip5: "↑ +7 PTS · V1→V2",
      chip6: "INTENT: ENERGETIC POP",
      chip7: "CONTROLLED BASS",

      sloganPart1: "Your",
      sloganEm: "studio",
      sloganPart2: "assistant",
      taglineBefore: "listens,",
      taglineEm: "understands",
      taglineAfter: ", guides.",
      heroSub: "Versions listens to your music, understands your intent, and guides you to improve your mix.",

      diffEyebrow: "OUR STRENGTHS",
      diffTitleStart: "Not a report.",
      diffTitleEm: "A conversation.",
      diffCard1Title: "A sound assistant who knows you",
      diffCard1Body: "Unlimited contextual chat — not a static report. Ask all your questions, get details, challenge the analysis. Versions keeps track of your project, version after version.",
      diffCard2Title: "Your intent comes first",
      diffCard2BodyBefore: "We don't judge your track in a vacuum. The analysis is calibrated to what ",
      diffCard2BodyEm: "you",
      diffCard2BodyAfter: " are after: the emotion, the genre, the sound you have in mind. Your references become the compass.",
      diffCard3Title: "Actionable recommendations",
      diffCard3Body: "No more \"your high mids are a bit busy\". Concrete technical values, frequency ranges, plugins matched to your DAW. You leave with a plan.",
      diffCard4Title: "Version-by-version tracking",
      diffCard4Body: "V1, V2, V3… Versions remembers every iteration. Progress is measured — you see what's improving and what still needs work, without starting from scratch each mix.",
      diffCard5Title: "Reports you work on together",
      diffCard5Body: "Share an analysis report with your producer, your label or another artist: each with their role, each with their comments. Feedback stays where it belongs — on the analysis, not scattered across messages.",
      diffCard6Title: "Online and at the heart of your DAW",
      diffCard6Body: "The full analysis on the site, and a plugin that lives in your session: metering, advice and express listens while you produce. The same assistant, from the first tweak to the final version.",

      axesEyebrow: "WHAT WE ANALYZE",
      axesTitleStart: "Six axes,",
      axesTitleEm: "one complete listen.",
      axesLede: "Each axis combines objective DSP analysis with an AI judgment calibrated to your intent. No score is given without justification.",
      axe1Label: "Frequency balance",
      axe1Desc: "Lows, mids, highs — weighting between bands, masking, overall curve.",
      axe2Label: "Dynamics",
      axe2Desc: "Crest factor, dynamic range, transients, compression handling.",
      axe3Label: "Stereo image",
      axe3Desc: "Width, mono compatibility, L/R balance, element placement.",
      axe4Label: "Space and depth",
      axe4Desc: "Reverbs, delays, foreground/background, spatial reading of the mix.",
      axe5Label: "Overall coherence",
      axe5Desc: "Cohesion, flow between sections, sonic identity.",
      axe6Label: "Vocals",
      axe6Desc: "Intelligibility, presence, sibilance, integration with the rest of the mix.",

      nopeEyebrow: "WHAT WE DON'T DO",
      nopeTitleEm: "Honest",
      nopeTitleAfter: " about our limits.",
      nope1: "We don't dictate your arrangements. Structure, creative choices, artistic stance — that's your territory.",
      nope2: "We don't replace a human sound engineer. We make expertise accessible where it wasn't before — to prep your next studio session, not to skip it.",
      nope3: "The score isn't absolute truth. It's a reference point, calibrated to your intent, not a verdict.",

      footerQuoteStart: "Your music.",
      footerQuoteEm: "Your vision.",
      footerQuoteEnd: "Our guidance.",

      // ── DAW plugin — home integration (topbar + hero CTA + section) ──
      pluginNav: "Plugin",
      pluginNewBadge: "New",
      ctaPlugin: "Discover the plugin",
      plugEyebrow: "THE PLUGIN",
      plugTitleStart: "Your assistant,",
      plugTitleEm: "right inside your session.",
      plugLede: "Free unlimited pro metering, a chat that hears your session, a listening verdict in 30 seconds. And for the full report, versions.studio is waiting.",
      plugVideoNote: "Demo video",
      plugPoint1Title: "Real-time metering, free and unlimited",
      plugPoint1Body: "LUFS, true peak, spectrum, stereo image — while you mix, 100% local.",
      plugPoint2Title: "An AI assistant that hears your mix",
      plugPoint2Body: "Ask a question: the answer draws on your live measurements and the plugins you actually own — not on generalities.",
      plugPoint3Title: "One instance per track, one overview",
      plugPoint3Body: "The plugin sees your whole session: masking detection, balance between tracks, and advice that takes everything playing into account.",
      plugPoint4Title: "The express listen",
      plugPoint4Body: "30 seconds of listening, a verdict right in the chat — on your mix or a single track. 5 free every month, unlimited with a subscription.",
      plugCtaDownload: "Download for free",
    },

    /* ─────────────────────── PLUGIN PAGE (/plugin) ─────────────────── */
    pluginPage: {
      topbarHome: "Home",
      topbarCurrent: "Plugin",
      topbarBackAria: "Back to home",
      heroChip1: "-14.2 LUFS",
      heroChip2: "SCORE 82/100",
      heroChip3: "TRUE PEAK -1.1 dB",
      heroChip4: "SESSION · 5 TRACKS",
      heroTitleLine1: "Your assistant,",
      heroTitleLine2Before: "inside ",
      heroTitleLine2Em: "your DAW",
      heroTitleLine2After: ".",
      taglineBefore: "listens, ",
      taglineEm: "understands",
      taglineAfter: ", guides — while you mix.",
      heroSub: "The VERSiONS plugin lives in your session: it measures in real time, answers your questions based on what it hears, and gives you a listening verdict in 30 seconds — without exporting anything.",
      chipFree: "FREE",
      ctaMac: "Download for Mac",
      ctaWin: "Download for Windows",
      ctaWinSoon: "Windows — coming soon",
      ctaComingSoon: "Download link coming soon",
      ctaAuthNote: "Download with a free account — the plugin asks you to sign in when it opens anyway.",
      videoNote: "Demo video",
      howEyebrow: "HOW IT WORKS",
      howTitleStart: "Three moves, ",
      howTitleEm: "zero export.",
      step1Title: "Drop it on your tracks and buses",
      step1Body: "Master, bass, vocals, etc. — one instance per track. Metering starts on its own, and the instances see each other.",
      step2Title: "Ask whatever you want",
      step2Body: "\"Is my bass masking my kick?\" The plugin reads your whole session and answers about your mix, not in theory.",
      step3Title: "Run an express listen",
      step3Body: "30 seconds of listening, a clear verdict in the chat. And for the full report, your versions.studio account is already linked.",
      featEyebrow: "WHAT IT CAN DO",
      featTitleStart: "It doesn't mix for you. ",
      featTitleEm: "It teaches you how to mix.",
      feat1Tag: "Free · unlimited",
      feat1Title: "Real-time metering",
      feat1Body: "LUFS, true peak, dynamic range, pro-grade spectrum, stereo image with correlation and width. The numbers that matter, readable at a glance, 100% local.",
      feat2Tag: "Included",
      feat2Title: "Session View",
      feat2Body: "One instance per track, and the plugin sees your whole console: calibrated masking detection, overlaid spectra, cross-track advice. Nobody else does this in dialogue.",
      feat3Tag: "15 messages/day free",
      feat3Title: "Chat in context",
      feat3Body: "You ask, it answers — drawing on your live measurements and what's playing in your session. In French or English.",
      feat4Tag: "5/month free",
      feat4Title: "Express listen",
      feat4Body: "The plugin listens to 30 seconds of your mix — or a single track — and gives you a clear verdict in the chat. Unlimited with the Indie and Pro subscriptions.",
      feat5Tag: "Included",
      feat5Title: "It knows your arsenal",
      feat5Body: "The plugin scans the plugins installed on your computer, and you choose which ones count. Recommendations name your EQs and compressors — not tools you don't own.",
      feat6Tag: "Included",
      feat6Title: "Calibrated to your setup",
      feat6Body: "Your favorite DAW, your listening setup — headphones or studio monitors —, your level: set your preferences once, and every answer takes them into account.",
      featNote: "Indie or Pro subscriber? Unlimited express listens and chat in the plugin. And the full analysis — score, element-by-element diagnosis, release verdict — lives on versions.studio, linked to your account.",
      footerQuoteStart: "Your music. ",
      footerQuoteEm: "Your vision.",
      footerQuoteEnd: "Our guidance — all the way into your DAW.",
      ctaFooterDownload: "Download the plugin",
      backToHome: "Back to home",
    },

    /* ─────────────────────── LEGAL PAGES ───────────────────── */
    legal: {
      common: {
        backToHome: "Back to home",
        privacyLink: "Privacy policy",
        termsLink: "Terms of service",
        navAria: "Legal pages",
      },
      privacy: {
        eyebrow: "PRIVACY",
        title: "Privacy",
        titleEm: "policy",
        updated: "Last updated: October 20, 2026",
        lede: "This policy describes how Versions collects, uses and protects your personal data when you use the service available at www.versions.studio.",
        sections: [
          {
            title: "1. Publisher identity",
            blocks: [
              { type: 'p', text: "The Versions service is published by **Archipel Audio** ({archipel}), a French simplified joint-stock company (SAS) registered under SIRET number 108 042 102 00013." },
              { type: 'p', text: "Contact: {publisherEmail}" },
            ],
          },
          {
            title: "2. Data collected and purposes",
            blocks: [
              { type: 'p', text: "We only collect data strictly necessary for the operation of the service:" },
              { type: 'ul', items: [
                "**Email address** — provided by Google during OAuth authentication, used to identify your account and to send you communications related to the service.",
                "**Audio files** — the tracks you upload for analysis (mix or master) are stored on Supabase Storage to enable playback, analysis by our engine and display of your analysis reports.",
                "**Analysis data** — results produced by the analysis engine (scores, diagnostics, DSP metrics), kept so you can review and compare your versions over time.",
                "**Technical fingerprint of audio files** — kept for operational purposes (analysis consistency, resource optimization). Deleted when you delete your account.",
                "**User preferences** — DAW used, interface language, artistic intents, profile settings.",
                "**Payment data** — handled entirely by Stripe; we do not store any banking data on our servers. Stripe only communicates the status of transactions (success, failure, active subscription) to us.",
                "**Archipel Audio news** — Archipel Audio, the publisher of Versions, may use your email address to occasionally present its other tools for musicians (AudioKit, AudioPass, Poll the Band). You can decline at sign-up, at any time from your Settings, or in one click in every email. We keep proof of your choice (version of the text shown, date, any objection).",
              ]},
            ],
          },
          {
            title: "3. Legal basis for processing",
            blocks: [
              { type: 'p', text: "Processing is based on:" },
              { type: 'ul', items: [
                "**Performance of the contract** between you and Versions when you create an account and use the service (article 6.1.b of the GDPR) — this is the primary legal basis for account management, audio file storage and analysis generation.",
                "**Your consent** (article 6.1.a of the GDPR) for authentication via Google, collected at the time of OAuth login.",
                "**The legitimate interest** of Archipel Audio in presenting products similar to Versions (article 6.1.f of the GDPR and article L34-5 of the French Postal and Electronic Communications Code) for Archipel Audio news, unless you decline — or **your consent** if you turned them on yourself from your Settings.",
                "**Legal obligations** applicable to the publisher (article 6.1.c), notably accounting and tax obligations for Stripe transactions.",
              ]},
            ],
          },
          {
            title: "4. Hosting and sub-processors",
            blocks: [
              { type: 'p', text: "Your data may be processed by our technical service providers: hosting (European Union and United States), payment, authentication and analysis. The detailed list is available upon request at {email}." },
            ],
          },
          {
            title: "5. Retention period",
            blocks: [
              { type: 'ul', items: [
                "**User account, audio files and analyses** — kept as long as your account is active, then 30 days after account deletion. You can delete each track individually from your dashboard at any time.",
                "**Billing data** — kept for 10 years in accordance with French accounting obligations.",
                "**Technical logs** — kept for a maximum of 12 months for security and debugging purposes.",
                "**Archipel Audio news** — your address is used as long as your account exists and you have not objected. Deleting your account ends it.",
              ]},
            ],
          },
          {
            title: "6. Your rights",
            blocks: [
              { type: 'p', text: "Pursuant to the General Data Protection Regulation (GDPR) and the French Data Protection Act, you have the following rights regarding your personal data:" },
              { type: 'ul', items: [
                "**Right of access** — obtain a copy of the data we hold about you.",
                "**Right of rectification** — correct any inaccurate or incomplete data.",
                "**Right to erasure** — request the deletion of your data.",
                "**Right to portability** — recover your data in a structured, machine-readable format.",
                "**Right to object** — object to a specific processing activity, and at any time, without giving a reason, to receiving Archipel Audio news (Settings or the unsubscribe link in every email).",
                "**Right to withdraw your consent** at any time, without affecting the lawfulness of prior processing.",
              ]},
              { type: 'p', text: "To exercise these rights, write to us at {email}. You also have the right to lodge a complaint with the CNIL (www.cnil.fr)." },
            ],
          },
          {
            title: "7. Cookies",
            blocks: [
              { type: 'p', text: "Versions uses **no tracking or advertising cookies**. Only cookies strictly necessary for the operation of the service are placed on your device:" },
              { type: 'ul', items: [
                "A session cookie tied to your authentication.",
                "Local storage entries (localStorage) used to remember your preferences (language, DAW, interface settings).",
              ]},
              { type: 'p', text: "As these trackers are strictly necessary to provide the service, they do not require prior consent in line with CNIL recommendations." },
            ],
          },
          {
            title: "8. Security",
            blocks: [
              { type: 'p', text: "All communications between your browser and our servers are encrypted via HTTPS. Access to your audio files is protected by Supabase's security policies (Row Level Security), which guarantee that only the owner of a file can access it." },
            ],
          },
          {
            title: "9. Changes",
            blocks: [
              { type: 'p', text: "We may update this policy to reflect legal or technical changes. Any substantial change will be notified to you by email or via a banner inside the application." },
            ],
          },
          {
            title: "10. Contact",
            blocks: [
              { type: 'p', text: "For any question regarding your personal data or this policy: {email}." },
            ],
          },
        ],
      },
      terms: {
        eyebrow: "TERMS",
        title: "Terms of",
        titleEm: "service",
        updated: "Last updated: October 20, 2026",
        lede: "These terms of service (\"Terms\") govern the access to and use of the Versions service, available at www.versions.studio. By creating an account or using the service, you accept these Terms without reservation.",
        sections: [
          {
            title: "1. Purpose of the service",
            blocks: [
              { type: 'p', text: "Versions is an online service for AI-powered audio mix analysis. It allows a user to upload an audio track (mix or master), receive a detailed analysis — frequency balance, dynamics, stereo image, listening quality — in the form of a report, and compare successive versions of the same track." },
              { type: 'p', text: "The service is intended for professional or personal use as part of the creative and technical music production process. It does not constitute a mastering service or the opinion of a certified sound engineer." },
            ],
          },
          {
            title: "2. Publisher",
            blocks: [
              { type: 'p', text: "The service is published by **Archipel Audio** ({archipel}), a French simplified joint-stock company (SAS) registered under SIRET number 108 042 102 00013." },
              { type: 'p', text: "Contact: {publisherEmail}" },
            ],
          },
          {
            title: "3. Registration and user account",
            blocks: [
              { type: 'p', text: "Access to the service requires creating an account via Google OAuth authentication. You warrant the accuracy of the information provided and undertake to keep your credentials confidential." },
              { type: 'p', text: "The account is strictly personal. You are solely responsible for any activity carried out from your account. You must notify us immediately of any unauthorized use." },
              { type: 'p', text: "You can delete your account at any time from your settings or by contacting us at {email}." },
            ],
          },
          {
            title: "4. Credits, subscription and billing",
            blocks: [
              { type: 'p', text: "The service operates on a credit system. Each analysis consumes one credit. Credits can be obtained:" },
              { type: 'ul', items: [
                "**Via a monthly subscription** — a number of credits is granted each month and expires at the end of the subscription period.",
                "**Via the purchase of one-off packs** — pack credits are cumulative and do not expire as long as your account remains active.",
              ]},
              { type: 'p', text: "Payments are processed by Stripe. No banking data is stored on our servers. Prices are listed in euros, including all applicable taxes where relevant." },
              { type: 'p', text: "In accordance with article L221-28 of the French Consumer Code, you waive your right of withdrawal for digital services delivered immediately after your order. This waiver is expressly accepted at the time of subscription." },
              { type: 'p', text: "You can cancel your subscription at any time from your settings. Cancellation takes effect at the end of the current billing period; no pro rata refund is issued." },
            ],
          },
          {
            title: "5. Intellectual property",
            blocks: [
              { type: 'p', text: "**Your audio files remain your exclusive property.** You retain all copyright, neighboring rights and master rights relating to the tracks you upload. Versions claims no rights over your works." },
              { type: 'p', text: "By uploading a track, you only grant us the limited, non-exclusive and revocable license necessary to store, play back and technically analyze the file as part of the service. This license ends when you delete the track or your account." },
              { type: 'p', text: "Analysis reports generated by Versions, as well as the elements of the interface (text, graphics, logos, code), are the property of the publisher and protected by intellectual property law. You can freely use the report contents for your own production needs, but you may not publicly reproduce or distribute the interface or the service without authorization." },
              { type: 'p', text: "You warrant that you hold all necessary rights to the files you upload, or that you are expressly authorized to analyze them on the service. This warranty is confirmed by an explicit acknowledgment at each upload. You undertake not to submit content that infringes third-party rights." },
            ],
          },
          {
            title: "6. Availability and liability",
            blocks: [
              { type: 'p', text: "We strive to ensure the availability of the service, but cannot guarantee uninterrupted operation. Maintenance operations, technical incidents or external factors may cause temporary unavailability." },
              { type: 'p', text: "Analyses produced by Versions are provided for guidance only. They cannot replace the opinion of a sound engineer and do not bind the publisher with regard to the final outcome of a production. The final artistic and technical decision belongs to you." },
              { type: 'p', text: "The publisher's liability cannot be engaged for indirect damages (data loss, loss of opportunity, loss of profit) arising from the use of the service. The publisher's total liability is in any event limited to the amount paid by the user during the previous twelve (12) months." },
            ],
          },
          {
            title: "7. Acceptable use",
            blocks: [
              { type: 'p', text: "You undertake not to:" },
              { type: 'ul', items: [
                "upload illegal, infringing content or content that violates third-party rights;",
                "attempt to access accounts or resources that do not belong to you;",
                "disrupt the operation of the service or circumvent its technical protections;",
                "massively or automatically extract content from the service for commercial purposes without authorization;",
                "use the service to train third-party artificial intelligence models.",
              ]},
              { type: 'p', text: "Any breach may result in the suspension or termination of your account, without prejudice to any compensation actions the publisher may take." },
            ],
          },
          {
            title: "8. Personal data",
            blocks: [
              { type: 'p', text: "The processing of your personal data is described in detail in our privacy policy (link at the bottom of this page). We process your data in compliance with the GDPR and the French Data Protection Act." },
            ],
          },
          {
            title: "9. Termination",
            blocks: [
              { type: 'p', text: "You can stop using the service and delete your account at any time. The publisher may suspend or terminate a user's access in case of breach of these Terms, after notification where reasonably possible." },
              { type: 'p', text: "Upon termination, audio files and associated data are deleted within 30 days, subject to legal retention obligations (accounting, tax)." },
            ],
          },
          {
            title: "10. Changes to the Terms",
            blocks: [
              { type: 'p', text: "These Terms may be updated to reflect changes in the service or the legal framework. Any substantial change will be notified to you by email or via a banner inside the application. Continued use of the service after notification constitutes acceptance of the new Terms." },
            ],
          },
          {
            title: "11. Governing law and jurisdiction",
            blocks: [
              { type: 'p', text: "These Terms are governed by French law. Failing an amicable resolution, any dispute relating to their performance or interpretation will be submitted to the competent French courts, save for any mandatory legal provision to the contrary." },
              { type: 'p', text: "In accordance with articles L611-1 et seq. of the French Consumer Code, consumer users may resort to a consumer mediator or use the European online dispute resolution platform available at https://ec.europa.eu/consumers/odr." },
            ],
          },
          {
            title: "12. Contact",
            blocks: [
              { type: 'p', text: "For any question regarding these Terms: {email}." },
            ],
          },
        ],
      },
    },
  },
};

/* ────────────────────────────────────────────────────────────
 * Helper `pick(lang, 'fiche.tabAnalysis')` — accès pointé pratique
 * avec fallback FR si clé manquante en EN (et vice-versa).
 * ──────────────────────────────────────────────────────────── */
export function pick(lang, path, vars) {
  const walk = (obj) => {
    try {
      return path.split(".").reduce((acc, k) => (acc == null ? undefined : acc[k]), obj);
    } catch { return undefined; }
  };
  let v = walk(STRINGS[lang]);
  if (v == null) v = walk(STRINGS.fr); // fallback FR
  if (typeof v === "string" && vars) {
    Object.keys(vars).forEach((k) => {
      v = v.replace(new RegExp(`\\{${k}\\}`, "g"), vars[k]);
    });
  }
  return v == null ? path : v;
}

export default STRINGS;
